/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

export abstract class BaseClient {
  protected abstract getDefaultHeaders(): Promise<HeadersInit>;

  protected async transformOptions(options: RequestInit, url: string) {
    const _defaultHeaders = await this.getDefaultHeaders();
    const _headers = new Headers(_defaultHeaders);
    const _runtimeHeaders = new Headers(options.headers);

    _runtimeHeaders.forEach((value, name) => _headers.set(name, value));

    const excludeXAccountId = !!(
      url &&
      EXCLUDE_HEADER_X_ACCOUNT_ID_ENDPOINTS.some(ep => {
        const _url = new URL(url);
        const curatedUrl = url.replace(_url.search, '');
        return curatedUrl.endsWith(ep);
      })
    );

    if (excludeXAccountId) {
      _headers.delete(HEADER_X_ACCOUNT_ID);
    }

    options.headers = _headers;
    return options;
  }
}

export abstract class ApiClient extends BaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    
    private baseUrl: string;
    private additionalHeaders: Record<string, unknown> | undefined;

    public jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : <any>window;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    public setBaseUrl(baseUrl: string){
        this.baseUrl = baseUrl;
    }

    public setAdditionalHeaders(values: Record<string, unknown> | undefined) {
        this.additionalHeaders = values;
    }

    public onError: (response: Response) => void = _ => {};

    /**
     * Validate tag format and existence
     * @param body (optional) 
     * @return Success
     */
    validateTag(body: ValidateTagRequest | undefined): Promise<ValidateTagResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/account/tag/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processValidateTag(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processValidateTag(response: Response): Promise<ValidateTagResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ValidateTagResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateTagResponseApiResponse>(<any>null);
    }

    /**
     * Update account tag
     * @return Success
     */
    getTag(): Promise<GetTagResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/account/tag/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetTag(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetTag(response: Response): Promise<GetTagResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetTagResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetTagResponseApiResponse>(<any>null);
    }

    /**
     * Get alerts
     * @return Success
     */
    getAlerts(): Promise<AlertsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/account/alerts/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAlerts(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAlerts(response: Response): Promise<AlertsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AlertsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AlertsResponseApiResponse>(<any>null);
    }

    /**
     * Dismiss alerts
     * @param body (optional) 
     * @return Success
     */
    dismissAlert(body: DismissAlertRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/account/alerts/dismiss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDismissAlert(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDismissAlert(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateYieldPromptAction(body: YieldPromptRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/account/yield-prompt";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processUpdateYieldPromptAction(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processUpdateYieldPromptAction(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    listUsers(): Promise<UserAndRoleArrayApiResponse> {
        let url_ = this.baseUrl + "/v1/account/list-users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processListUsers(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processListUsers(response: Response): Promise<UserAndRoleArrayApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserAndRoleArrayApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserAndRoleArrayApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    updateLabel(body: UpdateAccountLabelRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/account/label/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processUpdateLabel(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processUpdateLabel(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Get a single deposit
     * @param body (optional) 
     * @return Success
     */
    getAccountBalanceHistory(body: GetAccountBalanceHistoryRequest | undefined): Promise<GetAccountBalanceHistoryResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/account-balance-history/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAccountBalanceHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAccountBalanceHistory(response: Response): Promise<GetAccountBalanceHistoryResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetAccountBalanceHistoryResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountBalanceHistoryResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBalanceHistoryMarkers(body: GetAccountBalanceHistoryMarkersRequest | undefined): Promise<GetAccountBalanceHistoryMarkersResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/account-balance-history/markers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetBalanceHistoryMarkers(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetBalanceHistoryMarkers(response: Response): Promise<GetAccountBalanceHistoryMarkersResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetAccountBalanceHistoryMarkersResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountBalanceHistoryMarkersResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAssetBalanceHistory(body: GetAssetBalanceHistoryRequest | undefined): Promise<GetAssetBalanceHistoryResponseArrayApiResponse> {
        let url_ = this.baseUrl + "/v1/account-balance-history/get-asset-balance-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAssetBalanceHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAssetBalanceHistory(response: Response): Promise<GetAssetBalanceHistoryResponseArrayApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetAssetBalanceHistoryResponseArrayApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAssetBalanceHistoryResponseArrayApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    accountStatementList(body: ListAccountStatementRequest | undefined): Promise<GroupedAccountStatementArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/account-statement/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processAccountStatementList(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processAccountStatementList(response: Response): Promise<GroupedAccountStatementArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GroupedAccountStatementArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GroupedAccountStatementArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    accountStatementListFull(body: ListAccountStatementRequest | undefined): Promise<AccountStatementResponsePaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/account-statement/list-full";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processAccountStatementListFull(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processAccountStatementListFull(response: Response): Promise<AccountStatementResponsePaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountStatementResponsePaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountStatementResponsePaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getStatementPdf(body: string | undefined): Promise<GetStatementPdfResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/account-statement/pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetStatementPdf(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetStatementPdf(response: Response): Promise<GetStatementPdfResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetStatementPdfResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetStatementPdfResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getStatementPdfModel(): Promise<StatementPdfReportRequestApiResponse> {
        let url_ = this.baseUrl + "/v1/account-statement/get-statementpdf-model";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetStatementPdfModel(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetStatementPdfModel(response: Response): Promise<StatementPdfReportRequestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StatementPdfReportRequestApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StatementPdfReportRequestApiResponse>(<any>null);
    }

    /**
     * Get the trades associated with this account.
     * @param body (optional) 
     * @return Success
     */
    getActivityHistory(body: GetActivityHistoryRequest | undefined): Promise<ActivityArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/activity/get-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetActivityHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetActivityHistory(response: Response): Promise<ActivityArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ActivityArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * Get the trades associated with this account.
     * @param body (optional) 
     * @return Success
     */
    getAccountStatementCsv(body: GetActivityHistoryRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/activity/get-account-statement-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAccountStatementCsv(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAccountStatementCsv(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActivityTransactions(body: GetActivityTransactionsRequest | undefined): Promise<ActivityTransactionArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/activity/get-transactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetActivityTransactions(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetActivityTransactions(response: Response): Promise<ActivityTransactionArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ActivityTransactionArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ActivityTransactionArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getActivityTransactionsCsv(body: GetActivityTransactionsRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/activity/get-transactions/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetActivityTransactionsCsv(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetActivityTransactionsCsv(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleAccountStateOperation(body: ToggleAccountStatusOperationRequest | undefined): Promise<CreateQuorumOperationApiResponse> {
        let url_ = this.baseUrl + "/v1/admin/toggle-account-state-operation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processToggleAccountStateOperation(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processToggleAccountStateOperation(response: Response): Promise<CreateQuorumOperationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateQuorumOperationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateQuorumOperationApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    toggleUserStateOperation(body: ToggleUserStatusOperationRequest | undefined): Promise<CreateQuorumOperationApiResponse> {
        let url_ = this.baseUrl + "/v1/admin/toggle-user-state-operation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processToggleUserStateOperation(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processToggleUserStateOperation(response: Response): Promise<CreateQuorumOperationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateQuorumOperationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateQuorumOperationApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteBankAccountOperation(body: DeleteBankAccountRequest | undefined): Promise<CreateQuorumOperationApiResponse> {
        let url_ = this.baseUrl + "/v1/admin/delete-bank-account-operation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDeleteBankAccountOperation(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDeleteBankAccountOperation(response: Response): Promise<CreateQuorumOperationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateQuorumOperationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateQuorumOperationApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBankAccountOperation(body: CreateBankAccountRequest | undefined): Promise<CreateQuorumOperationApiResponse> {
        let url_ = this.baseUrl + "/v1/admin/create-bank-account-operation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateBankAccountOperation(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateBankAccountOperation(response: Response): Promise<CreateQuorumOperationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateQuorumOperationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateQuorumOperationApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWithdrawalAddressOperation(body: CreateWithdrawalAddressRequest | undefined): Promise<CreateQuorumOperationApiResponse> {
        let url_ = this.baseUrl + "/v1/admin/create-withdrawal-address-operation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateWithdrawalAddressOperation(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateWithdrawalAddressOperation(response: Response): Promise<CreateQuorumOperationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateQuorumOperationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateQuorumOperationApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteWithdrawalAddressOperation(body: DeleteWithdrawalAddressRequest | undefined): Promise<CreateQuorumOperationApiResponse> {
        let url_ = this.baseUrl + "/v1/admin/delete-withdrawal-address-operation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDeleteWithdrawalAddressOperation(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDeleteWithdrawalAddressOperation(response: Response): Promise<CreateQuorumOperationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateQuorumOperationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateQuorumOperationApiResponse>(<any>null);
    }

    /**
     * Get all Apex funds.
     * @param body (optional) 
     * @return Success
     */
    getAllApexFunds(body: GetApexFundsRequest | undefined): Promise<ApexFundArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/apex/get-funds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAllApexFunds(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAllApexFunds(response: Response): Promise<ApexFundArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApexFundArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApexFundArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * Get all Apex funds.
     * @param body (optional) 
     * @return Success
     */
    getApexFund(body: GetApexFundRequest | undefined): Promise<ApexFundApiResponse> {
        let url_ = this.baseUrl + "/v1/apex/get-fund";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetApexFund(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetApexFund(response: Response): Promise<ApexFundApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApexFundApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApexFundApiResponse>(<any>null);
    }

    /**
     * Get all your API Keys
     * @return Success
     */
    getApiKeys(): Promise<ApiKeyArrayApiResponse> {
        let url_ = this.baseUrl + "/v1/apikeys/get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetApiKeys(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetApiKeys(response: Response): Promise<ApiKeyArrayApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiKeyArrayApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiKeyArrayApiResponse>(<any>null);
    }

    /**
     * Create a new API Key.
    Multiple ip addresses can be passed separated by a ",".
     * @param body (optional) 
     * @return Success
     */
    createApiKey(body: CreateApiKeyRequest | undefined): Promise<CreateApiKeyResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/apikeys/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateApiKey(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateApiKey(response: Response): Promise<CreateApiKeyResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateApiKeyResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateApiKeyResponseApiResponse>(<any>null);
    }

    /**
     * Delete an API Key
     * @param body (optional) 
     * @return Success
     */
    deleteApiKey(body: DeleteApiKeyRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/apikeys/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDeleteApiKey(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDeleteApiKey(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Call this API to check if your authentication is still valid.
     * @param body (optional) 
     * @return Success
     */
    checkAuthentication(body: CheckApiKeyRequest | undefined): Promise<CheckApiKeyResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/check";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCheckAuthentication(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCheckAuthentication(response: Response): Promise<CheckApiKeyResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CheckApiKeyResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckApiKeyResponseApiResponse>(<any>null);
    }

    /**
     * Login with your username / password.
     * @param body (optional) 
     * @return Success
     */
    authenticate(body: AuthenticateRequest | undefined): Promise<AuthenticateResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processAuthenticate(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processAuthenticate(response: Response): Promise<AuthenticateResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthenticateResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticateResponseApiResponse>(<any>null);
    }

    /**
     * Complete a second factor challenge, using the token provided during the first phase.
     * @param body (optional) 
     * @return Success
     */
    completeChallenge(body: CompleteChallengeRequest | undefined): Promise<AuthenticateResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/complete-challenge";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCompleteChallenge(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCompleteChallenge(response: Response): Promise<AuthenticateResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthenticateResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticateResponseApiResponse>(<any>null);
    }

    /**
     * Validate invitation code
     * @param body (optional) 
     * @return Success
     */
    validateInvitationCode(body: ValidateInvitationCodeRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/validate-invitation-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processValidateInvitationCode(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processValidateInvitationCode(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Validate invitation code
     * @param body (optional) 
     * @return Success
     */
    validateReferralCode(body: ValidateReferralCodeRequest | undefined): Promise<ValidateReferralCodeResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/validate-referral-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processValidateReferralCode(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processValidateReferralCode(response: Response): Promise<ValidateReferralCodeResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ValidateReferralCodeResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateReferralCodeResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendVerificationEmail(body: ResendVerificationEmailRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/resend-verification-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processResendVerificationEmail(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processResendVerificationEmail(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyEmailAddress(body: VerifyEmailAddressRequest | undefined): Promise<VerifyEmailAddressResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/verify-email-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processVerifyEmailAddress(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processVerifyEmailAddress(response: Response): Promise<VerifyEmailAddressResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <VerifyEmailAddressResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyEmailAddressResponseApiResponse>(<any>null);
    }

    /**
     * Request a password reset via email.
    If valid, an email will be sent with a reset token.
     * @param body (optional) 
     * @return Success
     */
    sendResetPasswordEmail(body: ResetPasswordEmailRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/send-reset-password-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSendResetPasswordEmail(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSendResetPasswordEmail(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Renew the Jwt token.
     * @return Success
     */
    renewToken(): Promise<AuthenticateResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/new-token";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processRenewToken(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processRenewToken(response: Response): Promise<AuthenticateResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthenticateResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticateResponseApiResponse>(<any>null);
    }

    /**
     * Returns the current user's identity.
    To keep compatibility the identity is in the form of a JWT.
    This JWT is not persisted in the database, so it is not valid for authenticating.
     * @return Success
     */
    identity(): Promise<AuthenticateResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/identity";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processIdentity(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processIdentity(response: Response): Promise<AuthenticateResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthenticateResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticateResponseApiResponse>(<any>null);
    }

    /**
     * Logout and invalidates the current JWT
     * @return Success
     */
    logout(): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/logout";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processLogout(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processLogout(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    validatePassword(body: PasswordEntropyRequest | undefined): Promise<PasswordEntropyResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/validate-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processValidatePassword(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processValidatePassword(response: Response): Promise<PasswordEntropyResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PasswordEntropyResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PasswordEntropyResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAuthenticationMethod(body: GetAuthenticationMethodRequest | undefined): Promise<GetAuthenticationMethodResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/get-authentication-method";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAuthenticationMethod(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAuthenticationMethod(response: Response): Promise<GetAuthenticationMethodResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetAuthenticationMethodResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAuthenticationMethodResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    bcb(): Promise<void> {
        let url_ = this.baseUrl + "/test/bcb";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processBcb(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processBcb(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param assetCode (optional) 
     * @param amount (optional) 
     * @param note (optional) 
     * @return Success
     */
    add(assetCode: string | undefined, amount: number | undefined, note: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/test/bcb/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (assetCode === null || assetCode === undefined)
            throw new Error("The parameter 'assetCode' cannot be null.");
        else
            content_.append("assetCode", assetCode.toString());
        if (amount === null || amount === undefined)
            throw new Error("The parameter 'amount' cannot be null.");
        else
            content_.append("amount", amount.toString());
        if (note === null || note === undefined)
            throw new Error("The parameter 'note' cannot be null.");
        else
            content_.append("note", note.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processAdd(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processAdd(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getFrontendConfiguration(): Promise<FrontendConfigurationResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/configuration";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFrontendConfiguration(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFrontendConfiguration(response: Response): Promise<FrontendConfigurationResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FrontendConfigurationResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FrontendConfigurationResponseApiResponse>(<any>null);
    }

    /**
     * Get all the currencies that are available to trade.
    This is a public endpoint.
     * @param tenant (optional) 
     * @return Success
     */
    getCurrencies(tenant: string | undefined): Promise<CurrencyInformationArrayApiResponse> {
        let url_ = this.baseUrl + "/v1/currencies?";
        if (tenant === null)
            throw new Error("The parameter 'tenant' cannot be null.");
        else if (tenant !== undefined)
            url_ += "tenant=" + encodeURIComponent("" + tenant) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetCurrencies(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetCurrencies(response: Response): Promise<CurrencyInformationArrayApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CurrencyInformationArrayApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CurrencyInformationArrayApiResponse>(<any>null);
    }

    /**
     * Validates an address.
     * @param body (optional) 
     * @return Success
     */
    validateAddress(body: ValidateAddressRequest | undefined): Promise<ValidateAddressResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/currencies/validate-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processValidateAddress(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processValidateAddress(response: Response): Promise<ValidateAddressResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ValidateAddressResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ValidateAddressResponseApiResponse>(<any>null);
    }

    /**
     * Retrieve the deposit address for a specific currency
     * @param body (optional) 
     * @return Success
     */
    getDepositAddress(body: GetDepositAddressRequest | undefined): Promise<GetDepositAddressResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/deposits/get-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetDepositAddress(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetDepositAddress(response: Response): Promise<GetDepositAddressResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetDepositAddressResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetDepositAddressResponseApiResponse>(<any>null);
    }

    /**
     * Edit deposit description
     * @param body (optional) 
     * @return Success
     */
    setDepositDescription(body: SetDepositDescriptionRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/deposits/set-description";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSetDepositDescription(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSetDepositDescription(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Get all the deposits associated with your account.
     * @param body (optional) 
     * @return Success
     */
    getDepositHistory(body: GetDepositHistoryRequest | undefined): Promise<DepositArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/deposits/get-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetDepositHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetDepositHistory(response: Response): Promise<DepositArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DepositArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepositArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * Get a single deposit
     * @param body (optional) 
     * @return Success
     */
    getSingleDeposit(body: GetDepositRequest | undefined): Promise<DepositApiResponse> {
        let url_ = this.baseUrl + "/v1/deposits/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetSingleDeposit(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetSingleDeposit(response: Response): Promise<DepositApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DepositApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepositApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    listDepositableCurrencies(body: ListDepositableCurrenciesRequest | undefined): Promise<ListDepositableCurrenciesResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/deposits/list-depositable-currencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processListDepositableCurrencies(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processListDepositableCurrencies(response: Response): Promise<ListDepositableCurrenciesResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListDepositableCurrenciesResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListDepositableCurrenciesResponseApiResponse>(<any>null);
    }

    /**
     * Set device pin
     * @param body (optional) 
     * @return Success
     */
    setDevicePin(body: SetDevicePin | undefined): Promise<UpdatePinResultApiResponse> {
        let url_ = this.baseUrl + "/v1/device/set-pin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSetDevicePin(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSetDevicePin(response: Response): Promise<UpdatePinResultApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UpdatePinResultApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UpdatePinResultApiResponse>(<any>null);
    }

    /**
     * Validate device pin
     * @param body (optional) 
     * @return Success
     */
    verifyDevicePin(body: ValidateDevicePin | undefined): Promise<VerifyPinResultApiResponse> {
        let url_ = this.baseUrl + "/v1/device/verify-pin";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processVerifyDevicePin(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processVerifyDevicePin(response: Response): Promise<VerifyPinResultApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <VerifyPinResultApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VerifyPinResultApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    chargedFee(body: GetFeesChargedRequest | undefined): Promise<ChargedFeeApiResponse> {
        let url_ = this.baseUrl + "/v1/fees-charged/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processChargedFee(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processChargedFee(response: Response): Promise<ChargedFeeApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ChargedFeeApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ChargedFeeApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createFiatWithdrawal(body: CreateFiatWithdrawalRequest | undefined): Promise<FiatWithdrawalApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/create-withdrawal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateFiatWithdrawal(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateFiatWithdrawal(response: Response): Promise<FiatWithdrawalApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FiatWithdrawalApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FiatWithdrawalApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulateFiatWithdrawal(body: SimulateFiatWithdrawalRequest | undefined): Promise<FiatWithdrawalSimulationApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/simulate-withdrawal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSimulateFiatWithdrawal(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSimulateFiatWithdrawal(response: Response): Promise<FiatWithdrawalSimulationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FiatWithdrawalSimulationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FiatWithdrawalSimulationApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelFiatWithdrawal(body: CancelFiatWithdrawalRequest | undefined): Promise<FiatWithdrawalApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/cancel-withdrawal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCancelFiatWithdrawal(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCancelFiatWithdrawal(response: Response): Promise<FiatWithdrawalApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FiatWithdrawalApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FiatWithdrawalApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFiatWithdrawal(body: GetFiatWithdrawalRequest | undefined): Promise<FiatWithdrawalWithTimelineApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/get-withdrawal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFiatWithdrawal(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFiatWithdrawal(response: Response): Promise<FiatWithdrawalWithTimelineApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FiatWithdrawalWithTimelineApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FiatWithdrawalWithTimelineApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFiatDeposit(body: GetFiatWithdrawalRequest | undefined): Promise<FiatDepositApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/get-deposit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFiatDeposit(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFiatDeposit(response: Response): Promise<FiatDepositApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FiatDepositApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FiatDepositApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFiatWithdrawalHistory(body: GetFiatWithdrawalHistoryRequest | undefined): Promise<FiatWithdrawalArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/get-withdrawal-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFiatWithdrawalHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFiatWithdrawalHistory(response: Response): Promise<FiatWithdrawalArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FiatWithdrawalArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FiatWithdrawalArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFiatDepositHistory(body: GetFiatDepositHistoryRequest | undefined): Promise<FiatDepositArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/get-deposit-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFiatDepositHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFiatDepositHistory(response: Response): Promise<FiatDepositArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FiatDepositArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FiatDepositArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFiatDepositDetails(body: GetFiatDepositDetailsRequest | undefined): Promise<FiatDepositDetailsApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/get-fiat-deposit-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFiatDepositDetails(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFiatDepositDetails(response: Response): Promise<FiatDepositDetailsApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <FiatDepositDetailsApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FiatDepositDetailsApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBankAccountRequirements(body: BankAccountRequirementsInput | undefined): Promise<BankAccountRequirementsOutputApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/get-bank-account-requirements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetBankAccountRequirements(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetBankAccountRequirements(response: Response): Promise<BankAccountRequirementsOutputApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BankAccountRequirementsOutputApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankAccountRequirementsOutputApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createBankAccount(body: CreateBankAccountRequest | undefined): Promise<BankAccountApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/create-bank-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateBankAccount(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateBankAccount(response: Response): Promise<BankAccountApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BankAccountApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankAccountApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    verifyBankAccount(body: VerifyBankAccountRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/verify-bank-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processVerifyBankAccount(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processVerifyBankAccount(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendBankAccountVerificationCode(body: ResendBankAccountVerificationCodeRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/resend-bank-account-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processResendBankAccountVerificationCode(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processResendBankAccountVerificationCode(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteBankAccount(body: DeleteBankAccountRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/delete-bank-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDeleteBankAccount(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDeleteBankAccount(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBankAccounts(body: GetBankAccountsRequest | undefined): Promise<BankAccountArrayApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/get-bank-accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetBankAccounts(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetBankAccounts(response: Response): Promise<BankAccountArrayApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BankAccountArrayApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankAccountArrayApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getBankAccount(body: GetBankAccountRequest | undefined): Promise<BankAccountApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/get-bank-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetBankAccount(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetBankAccount(response: Response): Promise<BankAccountApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <BankAccountApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BankAccountApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    listFiatDepositableCurrencies(body: ListDepositableCurrenciesRequest | undefined): Promise<ListDepositableCurrenciesResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/fiat/list-fiat-depositable-currencies";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processListFiatDepositableCurrencies(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processListFiatDepositableCurrencies(response: Response): Promise<ListDepositableCurrenciesResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListDepositableCurrenciesResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListDepositableCurrenciesResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMonthlyFundPerformances(body: GetMonthlyFundPerformancesRequest | undefined): Promise<GetMonthlyFundPerformancesResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/fund/get-monthly-performances";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetMonthlyFundPerformances(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetMonthlyFundPerformances(response: Response): Promise<GetMonthlyFundPerformancesResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetMonthlyFundPerformancesResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMonthlyFundPerformancesResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFundFacts(body: GetFundFactsRequest | undefined): Promise<GetFundFactsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/fund-facts/get-fund-facts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFundFacts(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFundFacts(response: Response): Promise<GetFundFactsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetFundFactsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFundFactsResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getFactSheets(body: GetFactSheetsRequest | undefined): Promise<GetFactSheetsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/fund-facts/get-fact-sheets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFactSheets(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFactSheets(response: Response): Promise<GetFactSheetsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetFactSheetsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFactSheetsResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadFactSheet(body: DownloadFactSheetsRequest | undefined): Promise<DownloadFactSheetsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/fund-facts/download-fact-sheet";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDownloadFactSheet(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDownloadFactSheet(response: Response): Promise<DownloadFactSheetsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DownloadFactSheetsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadFactSheetsResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getInterestHistory(body: InterestHistoryRequest | undefined): Promise<InterestHistoryResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/funds/get-interest-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetInterestHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetInterestHistory(response: Response): Promise<InterestHistoryResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InterestHistoryResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterestHistoryResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getInterestRates(): Promise<InterestRateResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/funds/get-interest-rates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetInterestRates(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetInterestRates(response: Response): Promise<InterestRateResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InterestRateResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InterestRateResponseApiResponse>(<any>null);
    }

    /**
     * Get the maximum amount of each currency that is available for you to trade.
     * @return Success
     */
    getMaximumTradableAmount(): Promise<GetMaximumTradableAmountResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/funds/get-max-tradable-amount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetMaximumTradableAmount(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetMaximumTradableAmount(response: Response): Promise<GetMaximumTradableAmountResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetMaximumTradableAmountResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetMaximumTradableAmountResponseApiResponse>(<any>null);
    }

    /**
     * Get all your funds.
     * @return Success
     */
    getFunds(): Promise<GetFundsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/funds/get-funds";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFunds(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFunds(response: Response): Promise<GetFundsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetFundsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFundsResponseApiResponse>(<any>null);
    }

    /**
     * Export account funds to csv
     * @return Success
     */
    getFundsCsv(): Promise<void> {
        let url_ = this.baseUrl + "/v1/funds/get-funds-csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFundsCsv(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFundsCsv(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Export account funds to csv as of given date
     * @param body (optional) 
     * @return Success
     */
    getFundsCsvAsOf(body: GetFundsAsOfRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/funds/get-funds-csv-as-of";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFundsCsvAsOf(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFundsCsvAsOf(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get all your funds.
     * @param body (optional) 
     * @return Success
     */
    getFundsAsOf(body: GetFundsAsOfRequest | undefined): Promise<GetFundsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/funds/get-funds-asof";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFundsAsOf(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFundsAsOf(response: Response): Promise<GetFundsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetFundsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFundsResponseApiResponse>(<any>null);
    }

    /**
     * Get FX rates.
     * @return Success
     */
    getFxRates(): Promise<GetFxRatesResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/fx/get-rates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFxRates(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFxRates(response: Response): Promise<GetFxRatesResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetFxRatesResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFxRatesResponseApiResponse>(<any>null);
    }

    /**
     * Get FX rates.
     * @param body (optional) 
     * @return Success
     */
    getFxRatesAsOf(body: GetFxRatesAsOfRequest | undefined): Promise<GetFxRatesResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/fx/get-rates-asof";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFxRatesAsOf(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFxRatesAsOf(response: Response): Promise<GetFxRatesResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetFxRatesResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFxRatesResponseApiResponse>(<any>null);
    }

    /**
     * Get FX rates. Rates not guaranteed to be update to date. For the most up to date rate data, the private endpoint `get-rates` is recommended.
     * @return Success
     */
    getFxRatesPublic(): Promise<GetFxRatesResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/public/fx/get-rates";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetFxRatesPublic(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetFxRatesPublic(response: Response): Promise<GetFxRatesResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetFxRatesResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetFxRatesResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getInvoicePdfModel(): Promise<InvoiceGenerationPdfReportRequestApiResponse> {
        let url_ = this.baseUrl + "/v1/invoice/get-invoicepdf-model";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetInvoicePdfModel(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetInvoicePdfModel(response: Response): Promise<InvoiceGenerationPdfReportRequestApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InvoiceGenerationPdfReportRequestApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceGenerationPdfReportRequestApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getInvoices(body: GetInvoicesRequest | undefined): Promise<InvoiceArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/invoice/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetInvoices(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetInvoices(response: Response): Promise<InvoiceArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InvoiceArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getInvoicePdf(body: GetInvoicePdfRequest | undefined): Promise<GetInvoicePdfResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/invoice/get-invoice-pdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetInvoicePdf(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetInvoicePdf(response: Response): Promise<GetInvoicePdfResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetInvoicePdfResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetInvoicePdfResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    payInvoice(body: PayInvoiceRequest | undefined): Promise<InvoiceApiResponse> {
        let url_ = this.baseUrl + "/v1/invoice/pay";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processPayInvoice(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processPayInvoice(response: Response): Promise<InvoiceApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InvoiceApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getInvoiceDetails(body: GetInvoiceDetailsRequest | undefined): Promise<InvoiceApiResponse> {
        let url_ = this.baseUrl + "/v1/invoice/get-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetInvoiceDetails(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetInvoiceDetails(response: Response): Promise<InvoiceApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InvoiceApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InvoiceApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    listAssets(body: MarketListAssetsRequest | undefined): Promise<SimplifiedListAssetArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/market/list";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processListAssets(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processListAssets(response: Response): Promise<SimplifiedListAssetArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <SimplifiedListAssetArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimplifiedListAssetArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    listAssetDetails(body: ListAssetDetailsRequest | undefined): Promise<ListAssetDetailsResponseArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/market/list/asset-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processListAssetDetails(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processListAssetDetails(response: Response): Promise<ListAssetDetailsResponseArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListAssetDetailsResponseArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListAssetDetailsResponseArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMarketAssets(body: MarketAssetListRequest | undefined): Promise<MarketAssetListItemArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/market/assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetMarketAssets(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetMarketAssets(response: Response): Promise<MarketAssetListItemArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MarketAssetListItemArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketAssetListItemArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getMarketAssetDetails(body: MarketAssetDetailsRequest | undefined): Promise<MarketAssetDetailsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/market/assets/details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetMarketAssetDetails(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetMarketAssetDetails(response: Response): Promise<MarketAssetDetailsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MarketAssetDetailsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketAssetDetailsResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    topAssets(): Promise<MarketPageTopAssetResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/market/top";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processTopAssets(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processTopAssets(response: Response): Promise<MarketPageTopAssetResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <MarketPageTopAssetResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MarketPageTopAssetResponseApiResponse>(<any>null);
    }

    /**
     * Get notification settings
     * @return Success
     */
    getNotificationsSettings(): Promise<NotificationsSettingsApiResponse> {
        let url_ = this.baseUrl + "/v1/notifications/get-notifications-settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetNotificationsSettings(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetNotificationsSettings(response: Response): Promise<NotificationsSettingsApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <NotificationsSettingsApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NotificationsSettingsApiResponse>(<any>null);
    }

    /**
     * Set notification settings
     * @param body (optional) 
     * @return Success
     */
    setNotificationsSettings(body: NotificationsSettings | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/notifications/set-notifications-settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSetNotificationsSettings(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSetNotificationsSettings(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOhlcvs(body: OhlcvsRequest | undefined): Promise<OhlcvArrayApiResponse> {
        let url_ = this.baseUrl + "/v1/ohlcv-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetOhlcvs(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetOhlcvs(response: Response): Promise<OhlcvArrayApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <OhlcvArrayApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OhlcvArrayApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    organizationListAccounts(): Promise<ListAccountsApiResponse> {
        let url_ = this.baseUrl + "/v1/organization/list-accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processOrganizationListAccounts(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processOrganizationListAccounts(response: Response): Promise<ListAccountsApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ListAccountsApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ListAccountsApiResponse>(<any>null);
    }

    /**
     * Get asset information for each user account.
     * @param body (optional) 
     * @return Success
     */
    getAssetHoldings(body: GetAssetHoldingsRequest | undefined): Promise<GetAssetHoldingsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/organization/list-asset-holdings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAssetHoldings(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAssetHoldings(response: Response): Promise<GetAssetHoldingsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetAssetHoldingsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAssetHoldingsResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getAllAssetsHoldings(): Promise<GetAllAssetsHoldingsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/organization/list-all-assets-holdings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAllAssetsHoldings(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAllAssetsHoldings(response: Response): Promise<GetAllAssetsHoldingsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetAllAssetsHoldingsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAllAssetsHoldingsResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getAccountDetails(): Promise<AccountDetailApiResponse> {
        let url_ = this.baseUrl + "/v1/organization/get-account-details";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAccountDetails(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAccountDetails(response: Response): Promise<AccountDetailApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountDetailApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountDetailApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getAccountDetailsCsv(): Promise<void> {
        let url_ = this.baseUrl + "/v1/organization/get-account-details-csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAccountDetailsCsv(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAccountDetailsCsv(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountDetailsAsOf(body: GetAccountDetailsAsOfRequest | undefined): Promise<AccountDetailApiResponse> {
        let url_ = this.baseUrl + "/v1/organization/get-account-details-as-of";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAccountDetailsAsOf(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAccountDetailsAsOf(response: Response): Promise<AccountDetailApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountDetailApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountDetailApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountDetailsAsOfCsv(body: GetAccountDetailsAsOfRequest | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/organization/get-account-details-as-of-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAccountDetailsAsOfCsv(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAccountDetailsAsOfCsv(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getAccountHoldingsCsv(): Promise<void> {
        let url_ = this.baseUrl + "/v1/organization/get-account-holdings/csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAccountHoldingsCsv(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAccountHoldingsCsv(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    downloadDocumentType(body: DownloadOrganizationDocumentRequest | undefined): Promise<GetOrganizationDocumentResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/organization/documents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDownloadDocumentType(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDownloadDocumentType(response: Response): Promise<GetOrganizationDocumentResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetOrganizationDocumentResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetOrganizationDocumentResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkPartnerAuthentication(body: CheckPartnerAuthenticationRequest | undefined): Promise<CheckPartnerAuthenticationResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/partners/check-authentication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCheckPartnerAuthentication(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCheckPartnerAuthentication(response: Response): Promise<CheckPartnerAuthenticationResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CheckPartnerAuthenticationResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckPartnerAuthenticationResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createAccount(body: CreateAccountIntoOrganizationRequest | undefined): Promise<CreateAccountIntoOrganizationResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/partners/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateAccount(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateAccount(response: Response): Promise<CreateAccountIntoOrganizationResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateAccountIntoOrganizationResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAccountIntoOrganizationResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPartnerDepositAddress(body: DepositAddressRequest | undefined): Promise<DepositAddressResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/partners/accounts/deposit-addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetPartnerDepositAddress(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetPartnerDepositAddress(response: Response): Promise<DepositAddressResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <DepositAddressResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DepositAddressResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    checkPartnerAuthentication2(body: CheckPartnerAuthenticationRequest | undefined): Promise<CheckPartnerAuthenticationResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/partners/accounts/check-authentication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCheckPartnerAuthentication2(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCheckPartnerAuthentication2(response: Response): Promise<CheckPartnerAuthenticationResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CheckPartnerAuthenticationResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CheckPartnerAuthenticationResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createOrganization(body: CreateOrganizationRequest | undefined): Promise<CreateOrganizationResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/partners/organizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateOrganization(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateOrganization(response: Response): Promise<CreateOrganizationResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <CreateOrganizationResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateOrganizationResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPayment(body: GetPaymentRequest | undefined): Promise<PaymentApiResponse> {
        let url_ = this.baseUrl + "/v1/payments/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetPayment(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetPayment(response: Response): Promise<PaymentApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PaymentApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPaymentHistory(body: GetPaymentHistoryRequest | undefined): Promise<PaymentArrayApiResponse> {
        let url_ = this.baseUrl + "/v1/payments/get-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetPaymentHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetPaymentHistory(response: Response): Promise<PaymentArrayApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PaymentArrayApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentArrayApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulatePayment(body: SimulatePaymentRequest | undefined): Promise<PaymentSimulationApiResponse> {
        let url_ = this.baseUrl + "/v1/payments/simulate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSimulatePayment(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSimulatePayment(response: Response): Promise<PaymentSimulationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PaymentSimulationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentSimulationApiResponse>(<any>null);
    }

    /**
     * Create a payment that involves a withdrawal and potentially a trade
     * @param body (optional) 
     * @return Success
     */
    createPayment(body: CreatePaymentRequest | undefined): Promise<PaymentApiResponse> {
        let url_ = this.baseUrl + "/v1/payments/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreatePayment(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreatePayment(response: Response): Promise<PaymentApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PaymentApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaymentApiResponse>(<any>null);
    }

    /**
     * Cancel a payment that involves a withdrawal
     * @param body (optional) 
     * @return Success
     */
    cancelPayment(body: CancelPaymentRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/payments/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCancelPayment(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCancelPayment(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    applyPromocode(body: ApplyPromocodeRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/promocodes/apply-promocode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processApplyPromocode(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processApplyPromocode(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Returns the last login date and IP address.
     * @return Success
     */
    getLastLoginDate(): Promise<LastLoginDateResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/last-login";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetLastLoginDate(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetLastLoginDate(response: Response): Promise<LastLoginDateResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <LastLoginDateResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<LastLoginDateResponseApiResponse>(<any>null);
    }

    /**
     * Update your password by providing the current one.
     * @param body (optional) 
     * @return Success
     */
    updatePassword(body: UpdatePasswordRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/update-password";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processUpdatePassword(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processUpdatePassword(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Retrieve the current security settings of your account.
     * @return Success
     */
    getAuthenticationSettings(): Promise<AuthenticationSettingsApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/settings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAuthenticationSettings(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAuthenticationSettings(response: Response): Promise<AuthenticationSettingsApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AuthenticationSettingsApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AuthenticationSettingsApiResponse>(<any>null);
    }

    /**
     * Enable app Authenticator on your account.
     * @param body (optional) 
     * @return Success
     */
    enableAppAuthenticator(body: EnableAppAuthenticatorRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/enable-app-authenticator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processEnableAppAuthenticator(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processEnableAppAuthenticator(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Disable Google Authenticator on your account.
     * @param body (optional) 
     * @return Success
     */
    disableAppAuthenticator(body: DisableAppAuthenticatorRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/disable-app-authenticator";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDisableAppAuthenticator(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDisableAppAuthenticator(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Disable MFA for a user.
     * @param body (optional) 
     * @return Success
     */
    disableAuth0Mfa(body: DisableAuth0MfaRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/authentication/disable-auth0-mfa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDisableAuth0Mfa(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDisableAuth0Mfa(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getPendingOperations(body: PendingOperationsRequest | undefined): Promise<QuorumOperationArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/quorum/get-pending-operations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetPendingOperations(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetPendingOperations(response: Response): Promise<QuorumOperationArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <QuorumOperationArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuorumOperationArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getOperationDetails(body: OperationDetailRequest | undefined): Promise<QuorumOperationApiResponse> {
        let url_ = this.baseUrl + "/v1/quorum/get-operation-details";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetOperationDetails(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetOperationDetails(response: Response): Promise<QuorumOperationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <QuorumOperationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuorumOperationApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    approveOperation(body: ApproveOperationRequest | undefined): Promise<QuorumOperationApiResponse> {
        let url_ = this.baseUrl + "/v1/quorum/approve-operation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processApproveOperation(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processApproveOperation(response: Response): Promise<QuorumOperationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <QuorumOperationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuorumOperationApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    cancelOperation(body: CancelOperationRequest | undefined): Promise<QuorumOperationApiResponse> {
        let url_ = this.baseUrl + "/v1/quorum/cancel-operation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCancelOperation(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCancelOperation(response: Response): Promise<QuorumOperationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <QuorumOperationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<QuorumOperationApiResponse>(<any>null);
    }

    /**
     * Authenticate a user to a private Pusher channel
     * @param body (optional) 
     * @return Success
     */
    authenticateToRealtimeChannels(body: AuthenticateToRealtimeChannelsRequest | undefined): Promise<PusherAuthenticationDataApiResponse> {
        let url_ = this.baseUrl + "/v1/realtime/authenticate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processAuthenticateToRealtimeChannels(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processAuthenticateToRealtimeChannels(response: Response): Promise<PusherAuthenticationDataApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <PusherAuthenticationDataApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PusherAuthenticationDataApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    reconciliation(): Promise<void> {
        let url_ = this.baseUrl + "/test/reconciliation";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processReconciliation(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processReconciliation(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    bcbBalance(): Promise<void> {
        let url_ = this.baseUrl + "/test/reconciliation/bcb-balance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processBcbBalance(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processBcbBalance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    bcbTransaction(): Promise<void> {
        let url_ = this.baseUrl + "/test/reconciliation/bcb-transaction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processBcbTransaction(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processBcbTransaction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    slsBalance(): Promise<void> {
        let url_ = this.baseUrl + "/test/reconciliation/sls-balance";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSlsBalance(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSlsBalance(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    slsTransaction(): Promise<void> {
        let url_ = this.baseUrl + "/test/reconciliation/sls-transaction";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSlsTransaction(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSlsTransaction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param assetCode (optional) 
     * @param balance (optional) 
     * @param date (optional) 
     * @return Success
     */
    add2(assetCode: string | undefined, balance: number | undefined, date: Date | undefined): Promise<void> {
        let url_ = this.baseUrl + "/test/reconciliation/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (assetCode === null || assetCode === undefined)
            throw new Error("The parameter 'assetCode' cannot be null.");
        else
            content_.append("assetCode", assetCode.toString());
        if (balance === null || balance === undefined)
            throw new Error("The parameter 'balance' cannot be null.");
        else
            content_.append("balance", balance.toString());
        if (date === null || date === undefined)
            throw new Error("The parameter 'date' cannot be null.");
        else
            content_.append("date", date.toJSON());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processAdd2(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processAdd2(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param assetCode (optional) 
     * @param amount (optional) 
     * @param note (optional) 
     * @param date (optional) 
     * @param bic (optional) 
     * @return Success
     */
    addTransaction(assetCode: string | undefined, amount: number | undefined, note: string | undefined, date: Date | undefined, bic: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/test/reconciliation/add-transaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (assetCode === null || assetCode === undefined)
            throw new Error("The parameter 'assetCode' cannot be null.");
        else
            content_.append("assetCode", assetCode.toString());
        if (amount === null || amount === undefined)
            throw new Error("The parameter 'amount' cannot be null.");
        else
            content_.append("amount", amount.toString());
        if (note === null || note === undefined)
            throw new Error("The parameter 'note' cannot be null.");
        else
            content_.append("note", note.toString());
        if (date === null || date === undefined)
            throw new Error("The parameter 'date' cannot be null.");
        else
            content_.append("date", date.toJSON());
        if (bic === null || bic === undefined)
            throw new Error("The parameter 'bic' cannot be null.");
        else
            content_.append("bic", bic.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processAddTransaction(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processAddTransaction(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    getReferrals(): Promise<GetReferralsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/referrals/get-referrals";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetReferrals(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetReferrals(response: Response): Promise<GetReferralsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetReferralsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReferralsResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getReferralActivationStatus(): Promise<GetReferralActivationStatusResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/referrals/is-referral-enabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetReferralActivationStatus(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetReferralActivationStatus(response: Response): Promise<GetReferralActivationStatusResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetReferralActivationStatusResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetReferralActivationStatusResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getRewards(): Promise<GetRewardsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/rewards/get-rewards";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetRewards(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetRewards(response: Response): Promise<GetRewardsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetRewardsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetRewardsResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getReward(body: GetRewardRequest | undefined): Promise<RewardApiResponse> {
        let url_ = this.baseUrl + "/v1/rewards/get-reward";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetReward(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetReward(response: Response): Promise<RewardApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <RewardApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RewardApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getAppSettings(): Promise<AppSettingsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/settings/app";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAppSettings(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAppSettings(response: Response): Promise<AppSettingsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AppSettingsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AppSettingsResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getAccountSettings(): Promise<AccountSettingsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/settings/account";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAccountSettings(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAccountSettings(response: Response): Promise<AccountSettingsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <AccountSettingsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AccountSettingsResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getAccountStatement(body: GetAccountStatementRequest | undefined): Promise<GetAccountStatementResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/statement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetAccountStatement(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetAccountStatement(response: Response): Promise<GetAccountStatementResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetAccountStatementResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetAccountStatementResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getStaticData(): Promise<StaticDataResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/static-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetStaticData(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetStaticData(response: Response): Promise<StaticDataResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StaticDataResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StaticDataResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    getStaticDataV2(): Promise<StaticDataV2ResponseApiResponse> {
        let url_ = this.baseUrl + "/v2/static-data";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetStaticDataV2(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetStaticDataV2(response: Response): Promise<StaticDataV2ResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StaticDataV2ResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StaticDataV2ResponseApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    ping(): Promise<StringApiResponse> {
        let url_ = this.baseUrl + "/v1/system/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processPing(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processPing(response: Response): Promise<StringApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StringApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    whoAmI(): Promise<StringApiResponse> {
        let url_ = this.baseUrl + "/v1/system/whoami";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processWhoAmI(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processWhoAmI(response: Response): Promise<StringApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StringApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringApiResponse>(<any>null);
    }

    /**
     * @param emailAddress (optional) 
     * @return Success
     */
    test(emailAddress: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/test?";
        if (emailAddress === null)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else if (emailAddress !== undefined)
            url_ += "emailAddress=" + encodeURIComponent("" + emailAddress) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processTest(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processTest(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    verifyEncryption(): Promise<void> {
        let url_ = this.baseUrl + "/test/verify-encryption";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processVerifyEncryption(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processVerifyEncryption(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param dateTime (optional) 
     * @param action (optional) 
     * @return Success
     */
    setTime(dateTime: string | undefined, action: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/test/set-time";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (dateTime === null || dateTime === undefined)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else
            content_.append("dateTime", dateTime.toString());
        if (action === null || action === undefined)
            throw new Error("The parameter 'action' cannot be null.");
        else
            content_.append("action", action.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSetTime(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSetTime(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    runMtm(): Promise<void> {
        let url_ = this.baseUrl + "/test/run-mtm";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processRunMtm(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processRunMtm(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param input (optional) 
     * @return Success
     */
    removeAccents(input: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/test/remove-accents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (input === null || input === undefined)
            throw new Error("The parameter 'input' cannot be null.");
        else
            content_.append("input", input.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processRemoveAccents(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processRemoveAccents(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param firstname1 (optional) 
     * @param lastname1 (optional) 
     * @param firstname2 (optional) 
     * @param lastname2 (optional) 
     * @return Success
     */
    nameComparison(firstname1: string | undefined, lastname1: string | undefined, firstname2: string | undefined, lastname2: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/test/name-comparison";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (firstname1 === null || firstname1 === undefined)
            throw new Error("The parameter 'firstname1' cannot be null.");
        else
            content_.append("firstname1", firstname1.toString());
        if (lastname1 === null || lastname1 === undefined)
            throw new Error("The parameter 'lastname1' cannot be null.");
        else
            content_.append("lastname1", lastname1.toString());
        if (firstname2 === null || firstname2 === undefined)
            throw new Error("The parameter 'firstname2' cannot be null.");
        else
            content_.append("firstname2", firstname2.toString());
        if (lastname2 === null || lastname2 === undefined)
            throw new Error("The parameter 'lastname2' cannot be null.");
        else
            content_.append("lastname2", lastname2.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processNameComparison(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processNameComparison(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param emails (optional) 
     * @param index (optional) 
     * @param targetEmail (optional) 
     * @param success (optional) 
     * @return Success
     */
    sendTestEmail(emails: SendEmail[] | undefined, index: number | undefined, targetEmail: string | undefined, success: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/test/send-test-email";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (emails === null || emails === undefined)
            throw new Error("The parameter 'emails' cannot be null.");
        else
            emails.forEach(item_ => content_.append("Emails", item_.toString()));
        if (index === null || index === undefined)
            throw new Error("The parameter 'index' cannot be null.");
        else
            content_.append("Index", index.toString());
        if (targetEmail === null || targetEmail === undefined)
            throw new Error("The parameter 'targetEmail' cannot be null.");
        else
            content_.append("TargetEmail", targetEmail.toString());
        if (success === null || success === undefined)
            throw new Error("The parameter 'success' cannot be null.");
        else
            content_.append("Success", success.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSendTestEmail(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSendTestEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param targetEmail (optional) 
     * @param success (optional) 
     * @return Success
     */
    testEmails(targetEmail: string | undefined, success: boolean | undefined): Promise<void> {
        let url_ = this.baseUrl + "/test/emails?";
        if (targetEmail === null)
            throw new Error("The parameter 'targetEmail' cannot be null.");
        else if (targetEmail !== undefined)
            url_ += "targetEmail=" + encodeURIComponent("" + targetEmail) + "&";
        if (success === null)
            throw new Error("The parameter 'success' cannot be null.");
        else if (success !== undefined)
            url_ += "success=" + encodeURIComponent("" + success) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processTestEmails(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processTestEmails(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param dateTime (optional) 
     * @param emailAddress (optional) 
     * @param action (optional) 
     * @return Success
     */
    unlockAccount(dateTime: string | undefined, emailAddress: string | undefined, action: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/test/unlock-account";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (dateTime === null || dateTime === undefined)
            throw new Error("The parameter 'dateTime' cannot be null.");
        else
            content_.append("dateTime", dateTime.toString());
        if (emailAddress === null || emailAddress === undefined)
            throw new Error("The parameter 'emailAddress' cannot be null.");
        else
            content_.append("emailAddress", emailAddress.toString());
        if (action === null || action === undefined)
            throw new Error("The parameter 'action' cannot be null.");
        else
            content_.append("action", action.toString());

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processUnlockAccount(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processUnlockAccount(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    pingInternal(): Promise<StringApiResponse> {
        let url_ = this.baseUrl + "/v1/test/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processPingInternal(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processPingInternal(response: Response): Promise<StringApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <StringApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StringApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    error(): Promise<void> {
        let url_ = this.baseUrl + "/v1/test/error";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processError(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processError(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @return Success
     */
    createRandomUser(): Promise<UserInfoApiResponse> {
        let url_ = this.baseUrl + "/v1/test/create-random-user";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateRandomUser(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateRandomUser(response: Response): Promise<UserInfoApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserInfoApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserInfoApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    resetE2E(): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/test/reset-e2e";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processResetE2E(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processResetE2E(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    errorAuthenticated(): Promise<void> {
        let url_ = this.baseUrl + "/v1/test/error-authenticated";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processErrorAuthenticated(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processErrorAuthenticated(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param sym (optional) 
     * @param bid (optional) 
     * @param ask (optional) 
     * @return Success
     */
    setFxPrice(sym: string | undefined, bid: string | undefined, ask: string | undefined): Promise<void> {
        let url_ = this.baseUrl + "/v1/test/set-fx-price?";
        if (sym === null)
            throw new Error("The parameter 'sym' cannot be null.");
        else if (sym !== undefined)
            url_ += "sym=" + encodeURIComponent("" + sym) + "&";
        if (bid === null)
            throw new Error("The parameter 'bid' cannot be null.");
        else if (bid !== undefined)
            url_ += "bid=" + encodeURIComponent("" + bid) + "&";
        if (ask === null)
            throw new Error("The parameter 'ask' cannot be null.");
        else if (ask !== undefined)
            url_ += "ask=" + encodeURIComponent("" + ask) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSetFxPrice(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSetFxPrice(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    generateUsers(body: GenerateUsersRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/test/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGenerateUsers(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGenerateUsers(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    hasCancreateinternaltransfersClaim(): Promise<void> {
        let url_ = this.baseUrl + "/v1/test/has-cancreateinternaltransfers-claim";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "GET",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processHasCancreateinternaltransfersClaim(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processHasCancreateinternaltransfersClaim(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Check if Stablehouse is not in maintenance and currently authorizing trading.
    This is a public endpoint.
     * @return Success
     */
    isTradingEnabled(): Promise<TradingStatusApiResponse> {
        let url_ = this.baseUrl + "/v1/trades/is-trading-enabled";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processIsTradingEnabled(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processIsTradingEnabled(response: Response): Promise<TradingStatusApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TradingStatusApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TradingStatusApiResponse>(<any>null);
    }

    /**
     * Get the trades summary over a period of time.
     * @param body (optional) 
     * @return Success
     */
    getTradesVolumeSummary(body: TradesSummaryRequest | undefined): Promise<TradesSummaryResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/trades/get-volume";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetTradesVolumeSummary(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetTradesVolumeSummary(response: Response): Promise<TradesSummaryResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TradesSummaryResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TradesSummaryResponseApiResponse>(<any>null);
    }

    /**
     * Get the number of trade created/pending/executed for the account.
     * @return Success
     */
    getTradesCountSummary(): Promise<TradesCountSummaryApiResponse> {
        let url_ = this.baseUrl + "/v1/trades/get-count-summary";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetTradesCountSummary(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetTradesCountSummary(response: Response): Promise<TradesCountSummaryApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TradesCountSummaryApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TradesCountSummaryApiResponse>(<any>null);
    }

    /**
     * Returns the last 10 trades for a currency on the account.
     * @return Success
     */
    getLatestTradesForCurrency(currencyCode: string): Promise<GetLatestTradesResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/trades/get-latest/{currencyCode}";
        if (currencyCode === undefined || currencyCode === null)
            throw new Error("The parameter 'currencyCode' must be defined.");
        url_ = url_.replace("{currencyCode}", encodeURIComponent("" + currencyCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetLatestTradesForCurrency(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetLatestTradesForCurrency(response: Response): Promise<GetLatestTradesResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetLatestTradesResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLatestTradesResponseApiResponse>(<any>null);
    }

    /**
     * Returns the last 10 trades for all currencies on the account.
     * @return Success
     */
    getLatestTradesForAllCurrencies(): Promise<GetLatestTradesResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/trades/get-latest";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetLatestTradesForAllCurrencies(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetLatestTradesForAllCurrencies(response: Response): Promise<GetLatestTradesResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <GetLatestTradesResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<GetLatestTradesResponseApiResponse>(<any>null);
    }

    /**
     * Create a trade, where the funds used are already on the Stablehouse account.
     * @param body (optional) 
     * @return Success
     */
    createTrade(body: CreateTradeRequest | undefined): Promise<TradeApiResponse> {
        let url_ = this.baseUrl + "/v1/trades/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateTrade(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateTrade(response: Response): Promise<TradeApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TradeApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TradeApiResponse>(<any>null);
    }

    /**
     * Simulate a trade to know how much you will buy or sell.
     * @param body (optional) 
     * @return Success
     */
    simulateTrade(body: SimulateTradeRequest | undefined): Promise<TradeSimulationApiResponse> {
        let url_ = this.baseUrl + "/v1/trades/simulate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSimulateTrade(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSimulateTrade(response: Response): Promise<TradeSimulationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TradeSimulationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TradeSimulationApiResponse>(<any>null);
    }

    /**
     * Check a trade status.
     * @param body (optional) 
     * @return Success
     */
    getTrade(body: GetTradeStatusRequest | undefined): Promise<TradeApiResponse> {
        let url_ = this.baseUrl + "/v1/trades/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetTrade(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetTrade(response: Response): Promise<TradeApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TradeApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TradeApiResponse>(<any>null);
    }

    /**
     * Get the trades associated with this account.
     * @param body (optional) 
     * @return Success
     */
    getTradeHistory(body: GetTradeHistoryRequest | undefined): Promise<TradeArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/trades/get-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetTradeHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetTradeHistory(response: Response): Promise<TradeArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TradeArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TradeArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    listTradableAssets(body: GetTradableAssetsRequest | undefined): Promise<TradableAssetsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/trades/list-tradable-assets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processListTradableAssets(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processListTradableAssets(response: Response): Promise<TradableAssetsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TradableAssetsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TradableAssetsResponseApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTransfer(body: GetTransferRequest | undefined): Promise<TransferWithTimelineApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetTransfer(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetTransfer(response: Response): Promise<TransferWithTimelineApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TransferWithTimelineApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransferWithTimelineApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getTransferHistory(body: GetTransferHistoryRequest | undefined): Promise<TransferArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/get-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetTransferHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetTransferHistory(response: Response): Promise<TransferArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TransferArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransferArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendTransferVerificationCode(body: ResendTransferVerificationCodeRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/resend-transfer-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processResendTransferVerificationCode(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processResendTransferVerificationCode(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createInternalTransfer(body: CreateInternalTransferRequest | undefined): Promise<InternalTransferApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/create/internal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateInternalTransfer(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateInternalTransfer(response: Response): Promise<InternalTransferApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InternalTransferApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternalTransferApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulateInternalTransfer(body: CreateInternalTransferRequest | undefined): Promise<InternalTransferApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/simulate/internal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSimulateInternalTransfer(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSimulateInternalTransfer(response: Response): Promise<InternalTransferApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InternalTransferApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternalTransferApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getInternalTransfer(body: GetTransferRequest | undefined): Promise<InternalTransferWithTimelineApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/get/internal";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetInternalTransfer(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetInternalTransfer(response: Response): Promise<InternalTransferWithTimelineApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <InternalTransferWithTimelineApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InternalTransferWithTimelineApiResponse>(<any>null);
    }

    /**
     * Transfer a specific currency from your Stablehouse account to another Stablehouse account.
     * @param body (optional) 
     * @return Success
     */
    createTransfer(body: CreateTransferRequest | undefined): Promise<TransferApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateTransfer(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateTransfer(response: Response): Promise<TransferApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TransferApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransferApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    simulateTransfer(body: CreateTransferRequest | undefined): Promise<TransferSimulationApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/simulate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSimulateTransfer(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSimulateTransfer(response: Response): Promise<TransferSimulationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TransferSimulationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransferSimulationApiResponse>(<any>null);
    }

    /**
     * Confirm a transfer using a link sent by email. This request doesn't need to be authenticated,
    to allow the user to click on the link from another browser, or his smartphone
     * @param body (optional) 
     * @return Success
     */
    confirmTransferCode(body: ConfirmTransferRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/confirm-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processConfirmTransferCode(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processConfirmTransferCode(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Edit a transfer's description
     * @param body (optional) 
     * @return Success
     */
    setTransferDescription(body: SetTransferDescriptionRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/set-description";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSetTransferDescription(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSetTransferDescription(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Cancel a transfer
     * @param body (optional) 
     * @return Success
     */
    cancelTransfer(body: CancelTransferRequest | undefined): Promise<TransferApiResponse> {
        let url_ = this.baseUrl + "/v1/transfers/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCancelTransfer(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCancelTransfer(response: Response): Promise<TransferApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TransferApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TransferApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    searchExchanges(body: TravelRuleExchangeSearchRequest | undefined): Promise<TravelRuleExchangeSearchResponseArrayApiResponse> {
        let url_ = this.baseUrl + "/v1/travel-rule/search-exchanges";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSearchExchanges(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSearchExchanges(response: Response): Promise<TravelRuleExchangeSearchResponseArrayApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <TravelRuleExchangeSearchResponseArrayApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TravelRuleExchangeSearchResponseArrayApiResponse>(<any>null);
    }

    /**
     * @return Success
     */
    userMessages(): Promise<UserUnseenMessageTemplateDtoArrayApiResponse> {
        let url_ = this.baseUrl + "/v1/user-messages";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <RequestInit>{
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processUserMessages(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processUserMessages(response: Response): Promise<UserUnseenMessageTemplateDtoArrayApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <UserUnseenMessageTemplateDtoArrayApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UserUnseenMessageTemplateDtoArrayApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    accept(body: AcceptUserMessageRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/user-messages/accept";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processAccept(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processAccept(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result422);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    dismiss(body: DismissUserMessageRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/user-messages/dismiss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDismiss(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDismiss(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 422) {
            return response.text().then((_responseText) => {
            let result422: any = null;
            result422 = _responseText === "" ? null : <ProblemDetails>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Client Error", status, _responseText, _headers, result422);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    createWithdrawalAddress(body: CreateWithdrawalAddressRequest | undefined): Promise<WithdrawalAddressApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawal-addresses/create-withdrawal-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateWithdrawalAddress(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateWithdrawalAddress(response: Response): Promise<WithdrawalAddressApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WithdrawalAddressApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WithdrawalAddressApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmWithdrawalAddress(body: ConfirmWithdrawalAddressRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawal-addresses/confirm-withdrawal-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processConfirmWithdrawalAddress(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processConfirmWithdrawalAddress(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendWithdrawalAddressVerificationCode(body: ResendWithdrawalAddressVerificationCodeRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawal-addresses/resend-withdrawal-address-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processResendWithdrawalAddressVerificationCode(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processResendWithdrawalAddressVerificationCode(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    deleteWithdrawalAddress(body: DeleteWithdrawalAddressRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawal-addresses/delete-withdrawal-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processDeleteWithdrawalAddress(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processDeleteWithdrawalAddress(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWithdrawalAddresses(body: GetWithdrawalAddresses | undefined): Promise<WithdrawalAddressArrayApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawal-addresses/get-withdrawal-addresses";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetWithdrawalAddresses(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetWithdrawalAddresses(response: Response): Promise<WithdrawalAddressArrayApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WithdrawalAddressArrayApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WithdrawalAddressArrayApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWithdrawalAddress(body: GetWithdrawalAddress | undefined): Promise<WithdrawalAddressApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawal-addresses/get-withdrawal-address";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetWithdrawalAddress(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetWithdrawalAddress(response: Response): Promise<WithdrawalAddressApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WithdrawalAddressApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WithdrawalAddressApiResponse>(<any>null);
    }

    /**
     * Edit a withdrawal's description
     * @param body (optional) 
     * @return Success
     */
    setWithdrawalDescription(body: SetWithdrawalDescriptionRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawals/set-description";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSetWithdrawalDescription(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSetWithdrawalDescription(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Check a withdrawal status.
     * @param body (optional) 
     * @return Success
     */
    getWithdrawal(body: GetWithdrawalStatusRequest | undefined): Promise<WithdrawalWithTimelineApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawals/get";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetWithdrawal(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetWithdrawal(response: Response): Promise<WithdrawalWithTimelineApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WithdrawalWithTimelineApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WithdrawalWithTimelineApiResponse>(<any>null);
    }

    /**
     * Retrieve all the withdrawals associated with your account
     * @param body (optional) 
     * @return Success
     */
    getWithdrawalHistory(body: GetWithdrawalHistoryRequest | undefined): Promise<WithdrawalArrayPaginatedApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawals/get-history";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetWithdrawalHistory(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetWithdrawalHistory(response: Response): Promise<WithdrawalArrayPaginatedApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WithdrawalArrayPaginatedApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WithdrawalArrayPaginatedApiResponse>(<any>null);
    }

    /**
     * Withdraw a specific currency from your Stablehouse account.
     * @param body (optional) 
     * @return Success
     */
    createWithdrawal(body: CreateWithdrawalRequest | undefined): Promise<WithdrawalApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawals/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCreateWithdrawal(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCreateWithdrawal(response: Response): Promise<WithdrawalApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WithdrawalApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WithdrawalApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    resendWithdrawalVerificationCode(body: ResendWithdrawalVerificationCodeRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawals/resend-withdrawal-verification-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processResendWithdrawalVerificationCode(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processResendWithdrawalVerificationCode(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    confirmWithdrawalCode(body: ConfirmWithdrawalRequest | undefined): Promise<ApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawals/confirm-code";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processConfirmWithdrawalCode(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processConfirmWithdrawalCode(response: Response): Promise<ApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ApiResponse>(<any>null);
    }

    /**
     * Cancel a withdrawal
     * @param body (optional) 
     * @return Success
     */
    cancelWithdrawal(body: CancelWithdrawalRequest | undefined): Promise<WithdrawalApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawals/cancel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processCancelWithdrawal(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processCancelWithdrawal(response: Response): Promise<WithdrawalApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WithdrawalApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WithdrawalApiResponse>(<any>null);
    }

    /**
     * Withdraw a specific currency from your Stablehouse account.
     * @param body (optional) 
     * @return Success
     */
    simulateWithdrawal(body: SimulateWithdrawalRequest | undefined): Promise<WithdrawalSimulationApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawals/simulate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processSimulateWithdrawal(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processSimulateWithdrawal(response: Response): Promise<WithdrawalSimulationApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WithdrawalSimulationApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WithdrawalSimulationApiResponse>(<any>null);
    }

    /**
     * @param body (optional) 
     * @return Success
     */
    getWithdrawalRequirements(body: WithdrawalRequirementsRequest | undefined): Promise<WithdrawalRequirementsResponseApiResponse> {
        let url_ = this.baseUrl + "/v1/withdrawals/get-withdrawal-requirements";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <RequestInit>{
            body: content_,
            method: "POST",
            credentials: 'include',
            headers: {
                ...(this.additionalHeaders || {}),
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_, url_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            this.setAdditionalHeaders(undefined)
            return this.processGetWithdrawalRequirements(_response);
        })
        .catch((error: Error) => {
            if (error.message === 'Failed to fetch') {
                error.message = "An error occurred. Please try again";
            }
            throw error;
        });
    }

    protected processGetWithdrawalRequirements(response: Response): Promise<WithdrawalRequirementsResponseApiResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };

        if(status < 200 || status >= 400){
            return this.onError(response) as any;
        }
        if(status === 200 && response.type === 'cors' && response.redirected && response.url){
             return window.location.href = response.url as any;
        }

        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : <WithdrawalRequirementsResponseApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        } else if (status === 429) {
            return response.text().then((_responseText) => {
            return throwException("Too Many Requests", status, _responseText, _headers);
            });
        } else if (status === 503) {
            return response.text().then((_responseText) => {
            let result503: any = null;
            result503 = _responseText === "" ? null : <ApiResponse>JSON.parse(_responseText, this.jsonParseReviver);
            return throwException("Server Error", status, _responseText, _headers, result503);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WithdrawalRequirementsResponseApiResponse>(<any>null);
    }
}

export interface AcceptUserMessageRequest {
    userMessageId: string;
}

export interface AccountDetail {
    mtdPerformancePercent: string | null;
    ytdPerformancePercent: string | null;
    itdPerformancePercent: string | null;
    itdPnlUsd: string | null;
    hasPendingBalance: boolean;
    totalBalanceUsd: string | null;
    totalBalanceIncludingPendingUsd: string | null;
    balanceChange24HoursPercent: string | null;
    balanceChange1MonthPercent: string | null;
    balanceChange24HoursUsd: string | null;
    balanceChange1MonthUsd: string | null;
    totalCryptoUsd: string | null;
    totalPendingSettlementUsd: string | null;
    totalOpenOrdersUsd: string | null;
    totalPendingOutgoingUsd: string | null;
    totalPendingSendUsd: string | null;
    totalPendingOutgoingTransferOutUsd: string | null;
    totalPendingIncomingUsd: string | null;
    totalPendingReceiveUsd: string | null;
    totalPendingIncomingTransferInUsd: string | null;
    totalTradableUsd: string | null;
    totalWithdrawableUsd: string | null;
    totalFiatUsd: string | null;
    readonly canTrade: boolean;
    // @deprecated 
    readonly canAccountTransfer?: boolean;
    canSendAccountTransfer: boolean;
    canReceiveAccountTransfer: boolean;
    readonly canStabletagTransfer: boolean;
    readonly canReceiveCrypto: boolean;
    readonly canSendCrypto: boolean;
    readonly canReceiveCash: boolean;
    readonly canSendCash: boolean;
    readonly canPayInvoice: boolean;
    readonly earnedInterestTotalUsd: string | null;
    readonly earnedInterestThisWeekUsd: string | null;
    canWithdrawToNonWhitelistedAddress: boolean;
    enableBalanceGraph: boolean;
    showBalancesButton: boolean;
    dataAsOf: Date;
    dataLastUpdatedAsOf: Date | null;
    assets: AccountDetailAsset[] | null;
    provisionalAssets: ProvisionalAccountDetailAsset[] | null;
    account: AccountProperties | null;
    balanceHistoryStartDate: Date;
}

export interface AccountDetailApiResponse {
    result: AccountDetail | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface AccountDetailAsset {
    readonly currency: Currency | null;
    readonly canTrade: boolean;
    // @deprecated 
    readonly canAccountTransfer?: boolean;
    canSendAccountTransfer: boolean;
    canReceiveAccountTransfer: boolean;
    readonly canStabletagTransfer: boolean;
    readonly canReceiveCrypto: boolean;
    readonly canSendCrypto: boolean;
    readonly canReceiveCash: boolean;
    readonly canSendCash: boolean;
    readonly quantity: string | null;
    quantityIncludingPending: string | null;
    quantityIncludingPendingUsd: string | null;
    readonly pendingSettlementQuantity: string | null;
    readonly pendingSettlementQuantityUsd: string | null;
    tradableQuantity: string | null;
    tradableQuantityUsd: string | null;
    withdrawableQuantity: string | null;
    withdrawableQuantityUsd: string | null;
    transferableQuantityUsd: string | null;
    transferableQuantity: string | null;
    openOrdersQuantity: string | null;
    openOrdersQuantityUsd: string | null;
    pendingIncomingQuantity: string | null;
    pendingReceiveQuantity: string | null;
    pendingTransferInQuantity: string | null;
    pendingOutgoingQuantity: string | null;
    pendingOutgoingQuantityUsd: string | null;
    pendingSendQuantity: string | null;
    pendingSendQuantityUsd: string | null;
    pendingTransferOutQuantity: string | null;
    pendingTransferOutQuantityUsd: string | null;
    pendingIncomingQuantityUsd: string | null;
    pendingReceiveQuantityUsd: string | null;
    pendingTransferInQuantityUsd: string | null;
    readonly quantityUsd: string | null;
    readonly pendingQuantity: string | null;
    readonly pendingQuantityUsd: string | null;
    readonly earnedInterestTotal: string | null;
    readonly earnedInterestThisWeek: string | null;
    readonly earnedInterestTotalUsd: string | null;
    readonly earnedInterestThisWeekUsd: string | null;
    // @deprecated 
    readonly unitPrice?: string | null;
    hasPendingBalance: boolean;
    fundDetails: FundBalanceDetailDto | null;
    ytdPercent: string | null;
    qtdPercent: string | null;
    mtdPercent: string | null;
    ptdPercent: string | null;
    allReturnsPercent: string | null;
    ptdNetReturns: string | null;
    mtdNetReturns: string | null;
    qtdNetReturns: string | null;
    ytdNetReturns: string | null;
    allReturns: string | null;
    allocation: string | null;
    allReturnsPercentUsd: string | null;
    ptdPercentUsd: string | null;
    mtdPercentUsd: string | null;
    qtdPercentUsd: string | null;
    ytdPercentUsd: string | null;
}

export interface AccountProperties {
    accountId: string;
    accountName: string | null;
    accountNumber: string | null;
    accountType: AccountType;
    closed: boolean;
    readonly accountDisplayType: string | null;
    isCorporate: boolean;
    isYieldEligible: boolean;
    label: string | null;
}

export interface AccountSettingsResponse {
    canEarnYield: boolean;
    allowMatchInKindRewards: boolean;
    showYieldPrompt: boolean;
    hasDepositedEver: boolean;
    hasDepositedFiatEver: boolean;
    hasDepositedCryptoEver: boolean;
    enforce2FA: boolean;
    allowReferralRewards: boolean;
    allowStabletag: boolean;
    allowFeatureRequest: boolean;
    allowApiKeys: boolean;
    allowPayments: boolean;
    allowDeposits: boolean;
    allowTrades: boolean;
    allowWithdrawals: boolean;
    allowWithdrawalsWithoutWhitelistedAddress: boolean;
    withdrawalFeePercentage: number;
    withdrawalFeeCapUsd: number;
    fixedWithdrawalFeeRatio: number;
    accountType: SubAccountType;
    accountName: string | null;
    userType: UserType | null;
    kycTier: number;
    allowTransfers: boolean;
    is2FaEnabled: boolean;
    ask2FaForFiatWithdrawals: boolean;
    showFireblocksAlert: boolean;
    // @deprecated 
    display2FaAfterLogin?: TwoFaAfterLogin | null;
    proofOfAddressStatus: ProofOfAddressStatus;
    organizationId: string;
    organizationName: string | null;
    organizationIsCorporate: boolean;
    relationshipManagerName: string | null;
    relationshipManagerEmail: string | null;
    isWhiteLabel: boolean;
    label: string | null;
    relationshipManagerPhoneNumber: string | null;
    relationshipManagerTelegramId: string | null;
    whiteLabelLiteSettings: WhiteLabelLiteSettings | null;
    canCreateAddressBookEntries: boolean;
    canCreateBankAccounts: boolean;
    canSendAccountTransfer: boolean;
    canReceiveAccountTransfer: boolean;
    canManageUsers: boolean;
    canReadOtherFunds: boolean;
    canManageQuorumOperations: boolean;
    ask2FaForNewBankAccount: boolean;
    companyJurisdiction: CompanyJurisdictions;
}

export interface AccountSettingsResponseApiResponse {
    result: AccountSettingsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface AccountStatement {
    accountId: string;
    accountName: string | null;
    currency: Currency | null;
    accountNumber: string | null;
    accountType: AccountType;
    startDate: Date;
    endDate: Date;
    fileName: string | null;
    accountStatementId: string;
    accountLabel: string | null;
    periodName: string | null;
    periodType: string | null;
}

export interface AccountStatementOperation {
    amount: string | null;
    dateTime: Date;
    details: string | null;
    balance: string | null;
}

export interface AccountStatementResponse {
    statements: AccountStatement[] | null;
    firstStatementDate: Date | null;
}

export interface AccountStatementResponsePaginatedApiResponse {
    result: AccountStatementResponse | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum AccountType {
    Interest = "Interest",
    Custody = "Custody",
    Trading = "Trading",
    Pool = "Pool",
    ProTrading = "ProTrading",
    Vault = "Vault",
    Fund = "Fund",
}

export interface Activity {
    id: string;
    type: ActivityType;
    creationDate: Date;
    currency1: Currency | null;
    currency2: Currency | null;
    amount1: string | null;
    amount1Usd: string | null;
    amount2: string | null;
    rewardName: RewardName | null;
    confirmations: number;
    confirmationsNeeded: number;
    transferKind: TransferKind | null;
    activityLabel: ActivityLabel;
    isWaitingForConfirmations: boolean;
    accountName: string | null;
    accountNumber: string | null;
    accountType: AccountType;
    accountLabel: string | null;
    transferDestinationAccountId: string | null;
    transferDestinationAccountNumber: string | null;
    transferDestinationAccountLabel: string | null;
    transferDestinationTag: string | null;
    transferSourceAccountId: string | null;
    transferSourceAccountNumber: string | null;
    transferSourceAccountLabel: string | null;
    transferSourceTag: string | null;
    baseCurrency: Currency | null;
    quoteCurrency: Currency | null;
    side: Side;
    statusFilter: TransactionStatusFilter | null;
}

export interface ActivityArrayPaginatedApiResponse {
    result: Activity[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum ActivityLabel {
    Bought = "Bought",
    Sold = "Sold",
    Converted = "Converted",
    Sent = "Sent",
    Received = "Received",
    CashAdded = "CashAdded",
    CashWithdrawn = "CashWithdrawn",
    YieldPayout = "YieldPayout",
    Reward = "Reward",
    Payment = "Payment",
    EarnedFee = "EarnedFee",
    InvoicePayment = "InvoicePayment",
    ChargedFee = "ChargedFee",
    TransferIn = "TransferIn",
    TransferOut = "TransferOut",
    PaymentReceived = "PaymentReceived",
    FundSubscription = "FundSubscription",
    FundRedemption = "FundRedemption",
}

export interface ActivityTransaction {
    id: string;
    type: ActivityType;
    creationDate: Date;
    currency1: Currency | null;
    currency2: Currency | null;
    amount1: string | null;
    amount1Usd: string | null;
    amount2: string | null;
    rewardName: RewardName | null;
    confirmations: number;
    confirmationsNeeded: number;
    transferKind: TransferKind | null;
    activityLabel: ActivityLabel;
    isWaitingForConfirmations: boolean;
    accountName: string | null;
    accountNumber: string | null;
    accountType: AccountType;
    accountLabel: string | null;
    transferDestinationAccountId: string | null;
    transferDestinationAccountNumber: string | null;
    transferDestinationAccountLabel: string | null;
    transferDestinationTag: string | null;
    transferSourceAccountId: string | null;
    transferSourceAccountNumber: string | null;
    transferSourceAccountLabel: string | null;
    transferSourceTag: string | null;
    fee: string | null;
    feeUsd: string | null;
    feeCurrency: string | null;
    feesChargedType: FeesChargedType | null;
    title: string | null;
    description: string | null;
    sourceAddress: string | null;
    destinationAddress: string | null;
    price: number | null;
    priceContra: number | null;
    destinationAddressLabel: string | null;
    sourceAddressLabel: string | null;
    bankName: string | null;
    statusFilter: TransactionStatusFilter | null;
}

export interface ActivityTransactionArrayPaginatedApiResponse {
    result: ActivityTransaction[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum ActivityType {
    Deposit = "Deposit",
    EarnedFee = "EarnedFee",
    FiatDeposit = "FiatDeposit",
    FiatWithdrawal = "FiatWithdrawal",
    InternalTransfer = "InternalTransfer",
    InternalTransferIn = "InternalTransferIn",
    InternalTransferOut = "InternalTransferOut",
    Payment = "Payment",
    InvoicePayment = "InvoicePayment",
    Reward = "Reward",
    Trade = "Trade",
    Transfer = "Transfer",
    TransferIn = "TransferIn",
    TransferOut = "TransferOut",
    Unknown = "Unknown",
    YieldPayout = "YieldPayout",
    Withdrawal = "Withdrawal",
    ChargedFee = "ChargedFee",
    PaymentReceived = "PaymentReceived",
    FundSubscription = "FundSubscription",
    FundRedemption = "FundRedemption",
}

export enum AddressValidationStatus {
    Invalid = "Invalid",
    Valid = "Valid",
    Unknown = "Unknown",
}

export interface AlertsResponse {
    alerts: UserAlert[] | null;
}

export interface AlertsResponseApiResponse {
    result: AlertsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface AllowReceiveRequest {
    currencyCode: string;
    allowReceive: boolean;
}

export interface ApexFund {
    creationDate: Date;
    accountName: string | null;
    fundManagerName: string | null;
    accountId: string;
    active: boolean;
}

export interface ApexFundApiResponse {
    result: ApexFund | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface ApexFundArrayPaginatedApiResponse {
    result: ApexFund[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface ApiKey {
    key: string | null;
    name: string | null;
    ipAddresses: string | null;
    creationDate: Date;
    lastUsageDate: Date | null;
    canTrade: boolean;
    canWithdraw: boolean;
    canCreateApiKeys: boolean;
    accountId: string;
}

export interface ApiKeyArrayApiResponse {
    result: ApiKey[] | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface ApiResponse {
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface AppSettingsResponse {
    settings: { [key: string]: any; } | null;
}

export interface AppSettingsResponseApiResponse {
    result: AppSettingsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface ApplyPromocodeRequest {
    code: string | null;
}

export interface ApproveOperationRequest {
    id: string;
}

export interface AssetDetailData {
    cryptoMarketDetail: CryptoMarketDetail | null;
    fiatMarketDetail: FiatMarketDetail | null;
    fundMarketDetail: FundMarketDetail | null;
    bondMarketDetail: BondMarketDetail | null;
}

export interface AssetHolding {
    account: AccountProperties | null;
    readonly canTrade: boolean;
    // @deprecated 
    readonly canAccountTransfer?: boolean;
    canSendAccountTransfer: boolean;
    canReceiveAccountTransfer: boolean;
    readonly canStabletagTransfer: boolean;
    readonly canReceiveCrypto: boolean;
    readonly canSendCrypto: boolean;
    readonly canReceiveCash: boolean;
    readonly canSendCash: boolean;
    readonly quantity: string | null;
    quantityIncludingPending: string | null;
    quantityIncludingPendingUsd: string | null;
    readonly pendingSettlementQuantity: string | null;
    readonly pendingSettlementQuantityUsd: string | null;
    tradableQuantity: string | null;
    tradableQuantityUsd: string | null;
    withdrawableQuantity: string | null;
    withdrawableQuantityUsd: string | null;
    transferableQuantityUsd: string | null;
    transferableQuantity: string | null;
    openOrdersQuantity: string | null;
    openOrdersQuantityUsd: string | null;
    pendingIncomingQuantity: string | null;
    pendingReceiveQuantity: string | null;
    pendingTransferInQuantity: string | null;
    pendingOutgoingQuantity: string | null;
    pendingOutgoingQuantityUsd: string | null;
    pendingSendQuantity: string | null;
    pendingSendQuantityUsd: string | null;
    pendingTransferOutQuantity: string | null;
    pendingTransferOutQuantityUsd: string | null;
    pendingIncomingQuantityUsd: string | null;
    pendingReceiveQuantityUsd: string | null;
    pendingTransferInQuantityUsd: string | null;
    readonly quantityUsd: string | null;
    readonly pendingQuantity: string | null;
    readonly pendingQuantityUsd: string | null;
    readonly earnedInterestTotal: string | null;
    readonly earnedInterestThisWeek: string | null;
    readonly earnedInterestTotalUsd: string | null;
    readonly earnedInterestThisWeekUsd: string | null;
    // @deprecated 
    readonly unitPrice?: string | null;
    hasPendingBalance: boolean;
    fundDetails: FundBalanceDetailDto | null;
    ytdPercent: string | null;
    qtdPercent: string | null;
    mtdPercent: string | null;
    ptdPercent: string | null;
    allReturnsPercent: string | null;
    ptdNetReturns: string | null;
    mtdNetReturns: string | null;
    qtdNetReturns: string | null;
    ytdNetReturns: string | null;
    allReturns: string | null;
    allocation: string | null;
    allReturnsPercentUsd: string | null;
    ptdPercentUsd: string | null;
    mtdPercentUsd: string | null;
    qtdPercentUsd: string | null;
    ytdPercentUsd: string | null;
}

export interface AuthenticateRequest {
    email: string;
    password: string;
    recaptchaToken: string;
    tenant: string | null;
    siteCode: string | null;
}

export interface AuthenticateResponse {
    jwt: string | null;
    challenge: AuthenticationChallenge | null;
}

export interface AuthenticateResponseApiResponse {
    result: AuthenticateResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface AuthenticateToRealtimeChannelsRequest {
    socket: string | null;
    channelName: string | null;
}

export interface AuthenticationChallenge {
    token: string | null;
    type: AuthenticationChallengeType;
}

export enum AuthenticationChallengeType {
    AuthenticatorApp = "AuthenticatorApp",
    Fido = "Fido",
    Sms = "Sms",
}

export interface AuthenticationSettings {
    authenticatorAppEnabled: boolean;
    // @deprecated 
    googleAuthenticatorEnabled?: boolean;
    // @deprecated 
    appAuthenticatorEnabled?: boolean;
}

export interface AuthenticationSettingsApiResponse {
    result: AuthenticationSettings | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum AuthenticationType {
    Stablehouse = "Stablehouse",
    Auth0 = "Auth0",
}

export interface Balance {
    asset: string | null;
    assetInternalCode: string | null;
    amount: string | null;
}

export interface BankAccount {
    id: string;
    currency: Currency | null;
    bankAccountDetails: BankAccountDetails | null;
    status: CustomerBankAccountStatus;
}

export interface BankAccountApiResponse {
    result: BankAccount | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface BankAccountArrayApiResponse {
    result: BankAccount[] | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface BankAccountDetails {
    accountNumber: string;
    bankIdentifier: string;
    bankCountry: string;
    recipientAddress1: string | null;
    recipientAddress2: string | null;
    recipientCity: string | null;
    recipientState: string | null;
    recipientCountry: string | null;
    recipientPostalCode: string | null;
    intermediaryBankIdentifier: string | null;
    intermediaryAccountNumber: string | null;
    bankName: string | null;
    accountHolderName: string | null;
}

export enum BankAccountRequirementType {
    Optional = "Optional",
    Required = "Required",
    Hidden = "Hidden",
}

export interface BankAccountRequirementsInput {
    bankCountry: string | null;
    bankCurrency: string;
}

export interface BankAccountRequirementsOutput {
    readonly accountNumber: BankAccountRequirementType | null;
    readonly aba: BankAccountRequirementType | null;
    readonly bicSwift: BankAccountRequirementType | null;
    readonly iban: BankAccountRequirementType | null;
    readonly sortCode: BankAccountRequirementType | null;
    readonly intermediaryBicSwift: BankAccountRequirementType | null;
    readonly intermediaryAba: BankAccountRequirementType | null;
}

export interface BankAccountRequirementsOutputApiResponse {
    result: BankAccountRequirementsOutput | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface BondMarketDetail {
    yieldPercent: number | null;
    couponPercent: number | null;
    // @deprecated 
    price?: number | null;
    formattedPrice: string | null;
    maturity: Date | null;
    paymentFrequency: InterestPayment | null;
    issuanceAmount: number | null;
    issuanceAmountCurrency: string | null;
}

export interface CancelFiatDepositRequest {
    id: string;
}

export interface CancelFiatWithdrawalRequest {
    id: string;
}

export interface CancelOperationRequest {
    id: string;
    message: string;
}

export interface CancelPaymentRequest {
    paymentId: string;
}

export interface CancelTransferRequest {
    transferId: string;
}

export interface CancelWithdrawalRequest {
    withdrawalId: string;
}

export enum CandleResolutions {
    Minutes1 = "Minutes1",
    Minutes5 = "Minutes5",
    Hours1 = "Hours1",
    Hours4 = "Hours4",
    Days1 = "Days1",
    Week1 = "Week1",
}

export interface CategoriesPerAssetTypeItemV2Response {
    category: MarketAssetCategory;
    readonly displayCategory: string | null;
}

export interface CategoriesPerAssetTypeResponse {
    type: MarketAssetType;
    categories: MarketAssetCategory[] | null;
}

export interface CategoriesPerAssetTypeV2Response {
    type: MarketAssetType;
    readonly displayType: string | null;
    categories: CategoriesPerAssetTypeItemV2Response[] | null;
}

export interface ChargedFee {
    readonly id: string;
    readonly amount: number;
    readonly amountUsd: number;
    readonly creationDate: Date;
    readonly currency: Currency | null;
    readonly type: FeesChargedType;
}

export interface ChargedFeeApiResponse {
    result: ChargedFee | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface CheckApiKeyRequest {
}

export interface CheckApiKeyResponse {
    accountId: string;
}

export interface CheckApiKeyResponseApiResponse {
    result: CheckApiKeyResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface CheckPartnerAuthenticationRequest {
}

export interface CheckPartnerAuthenticationResponse {
    apiKey: string;
    tenant: string | null;
}

export interface CheckPartnerAuthenticationResponseApiResponse {
    result: CheckPartnerAuthenticationResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum CompanyJurisdictions {
    BDA = "BDA",
    UAE = "UAE",
}

export interface CompleteChallengeRequest {
    token: string;
    code: string;
}

export interface ConfirmTransferRequest {
    id: string;
    code: string;
}

export interface ConfirmWithdrawalAddressRequest {
    withdrawalAddressId: string;
    code: string;
}

export interface ConfirmWithdrawalRequest {
    withdrawalId: string;
    code: string;
}

export interface CreateAccountIntoOrganizationRequest {
    accountType: AccountType;
    organizationId: string;
}

export interface CreateAccountIntoOrganizationResponse {
    accountNumber: string | null;
    accountType: AccountType;
}

export interface CreateAccountIntoOrganizationResponseApiResponse {
    result: CreateAccountIntoOrganizationResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface CreateApiKeyRequest {
    name: string;
    passphrase: string | null;
    ipAddresses: string | null;
    canTrade: boolean;
    canWithdraw: boolean;
    canCreateApiKeys: boolean;
    canCreateInternalTransfer: boolean;
}

export interface CreateApiKeyResponse {
    key: string | null;
    secret: string | null;
    name: string | null;
    ipAddresses: string | null;
    passphrase: string | null;
    canTrade: boolean;
    canWithdraw: boolean;
    canCreateApiKeys: boolean;
}

export interface CreateApiKeyResponseApiResponse {
    result: CreateApiKeyResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface CreateBankAccountRequest {
    currencyCode: string;
    bankAccountDetails: BankAccountDetails | null;
    adhoc: boolean;
}

export interface CreateFiatDepositRequest {
    currencyCode: string;
    amount: string | null;
}

export interface CreateFiatWithdrawalRequest {
    currencyCode: string;
    amount: string;
    subtractFeeFromAmount: boolean;
    description: string | null;
    // @deprecated 
    bankNumber?: string | null;
    // @deprecated 
    accountNumber?: string | null;
    bankAccountId: string | null;
    appAuthenticatorCode: string | null;
    // @deprecated 
    googleAuthenticatorCode?: string | null;
}

export interface CreateInternalTransferRequest {
    destinationAccountId: string;
    sourceAccountId: string | null;
    currencyCode: string;
    amount: string;
    description: string | null;
    appAuthenticatorCode: string | null;
    // @deprecated 
    googleAuthenticatorCode?: string | null;
    clientId: string | null;
    // @deprecated 
    substractFeeFromAmount?: boolean;
    subtractFeeFromAmount: boolean | null;
}

export interface CreateOrganizationRequest {
    type: CreateOrganizationRequestType;
    email: string;
    firstName: string;
    lastName: string;
    riskRating: number;
    qualificationClassToken: string | null;
    externalOrganizationId: string | null;
    phoneNumber: string | null;
    tin: string | null;
    taxResidence: string | null;
    residentialCountry: string | null;
    nationality: string | null;
    companyLegalName: string | null;
    registrationNumber: string | null;
    registeredCountry: string | null;
    factaCrsClassification: string | null;
    organizationManagerFirstName: string | null;
    organizationManagerLastName: string | null;
    organizationManagerEmail: string | null;
    organizationManagerNationality: string | null;
    organizationManagerResidentialCountry: string | null;
}

export enum CreateOrganizationRequestType {
    Individual = "Individual",
    Company = "Company",
}

export interface CreateOrganizationResponse {
    organizationId: string;
    externalOrganizationId: string | null;
}

export interface CreateOrganizationResponseApiResponse {
    result: CreateOrganizationResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface CreatePaymentRequest {
    currencyTo: string;
    amountFrom: string | null;
    amountTo: string | null;
    destinationAddress: string;
    currencyFrom: string | null;
    description: string | null;
    appAuthenticatorCode: string | null;
    // @deprecated 
    googleAuthenticatorCode?: string | null;
    /** If AmountFrom and AmountTo are both specified,
SidePreference will be used to determine whether
the fixed amount is on the buy (To) side or the sell (From) side. */
    sidePreference: TradeSide | null;
    clientId: string | null;
}

export interface CreateQuorumOperationApiResponse {
    operationId: string;
    status: QuorumOperationStatus;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface CreateTradeRequest {
    currencyFrom: string;
    currencyTo: string;
    amountFrom: string | null;
    amountTo: string | null;
    /** If AmountFrom and AmountTo are both specified,
SidePreference will be used to determine whether
the fixed amount is on the buy (To) side or the sell (From) side. */
    sidePreference: TradeSide | null;
    clientId: string | null;
}

export interface CreateTransferRequest {
    sourceAccountId: string | null;
    destinationTag: string;
    currencyCode: string;
    amount: string;
    description: string | null;
    appAuthenticatorCode: string | null;
    // @deprecated 
    googleAuthenticatorCode?: string | null;
    clientId: string | null;
    // @deprecated 
    substractFeeFromAmount?: boolean;
    subtractFeeFromAmount: boolean | null;
}

export interface CreateWithdrawalAddress {
    label: string | null;
    currencyCode: string;
    address: string;
}

export interface CreateWithdrawalAddressRequest {
    withdrawalAddress: CreateWithdrawalAddress;
    appAuthenticatorCode: string | null;
    // @deprecated 
    googleAuthenticatorCode?: string | null;
}

export interface CreateWithdrawalRequest {
    currencyCode: string;
    amount: string;
    destinationAddress: string | null;
    withdrawalAddressId: string | null;
    subtractFeeFromAmount: boolean;
    description: string | null;
    appAuthenticatorCode: string | null;
    // @deprecated 
    googleAuthenticatorCode?: string | null;
    clientId: string | null;
    travelRuleBeneficiary: CreateWithdrawalTravelRuleRequest | null;
}

export interface CreateWithdrawalTravelRuleRequest {
    walletOwnerFirstName: string | null;
    walletOwnerLastName: string | null;
    walletType: TravelRuleWalletType | null;
    walletOwnerType: TravelRuleWalletOwnerType | null;
    walletProviderName: string | null;
    walletOwnerCompany: string | null;
    walletProviderDid: string | null;
    organizationTravelRuleAddressInfoId: string | null;
}

export interface CryptoMarketDetail {
    // @deprecated 
    price?: number | null;
    formattedPrice: string | null;
    change24hPercent: number | null;
    change1MonthPercent: number | null;
    change1YearPercent: number | null;
    volume24h: number | null;
    marketCap: number | null;
}

export interface Currency {
    name: string | null;
    decimals: number;
    pricePrecision: number;
    code: string | null;
    displayCode: string | null;
    blockchain: string | null;
    underlyingCurrencyCode: string | null;
    underlyingCurrencyName: string | null;
    apy: number;
    explorerUrl: string | null;
    blockchainAssetId: string | null;
    type: CurrencyType;
    isStablecoin: boolean;
}

export interface CurrencyInformation {
    // @deprecated 
    tradableCurrencies?: string[] | null;
    withdrawalsAllowed: boolean;
    depositsAllowed: boolean;
    tradingAllowed: boolean;
    apy: number;
    isDefaultFiatConversion: boolean;
    allowFiatConversion: boolean;
    hidden: boolean;
    showInMarkets: boolean;
    showInTopGainersOrLosers: boolean;
    name: string | null;
    decimals: number;
    pricePrecision: number;
    code: string | null;
    displayCode: string | null;
    blockchain: string | null;
    underlyingCurrencyCode: string | null;
    underlyingCurrencyName: string | null;
    explorerUrl: string | null;
    blockchainAssetId: string | null;
    type: CurrencyType;
    isStablecoin: boolean;
}

export interface CurrencyInformationArrayApiResponse {
    result: CurrencyInformation[] | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface CurrencyTradesSummary {
    currencyCode: string | null;
    amountBought: string | null;
    amountSold: string | null;
}

export enum CurrencyType {
    Digital = "Digital",
    Fiat = "Fiat",
    Fund = "Fund",
}

export enum CustomerBankAccountStatus {
    Verifying = "Verifying",
    Ready = "Ready",
}

export interface DataPoint {
    date: Date;
    value: number;
}

export interface DeleteApiKeyRequest {
    key: string | null;
}

export interface DeleteBankAccountRequest {
    bankAccountId: string;
}

export interface DeleteWithdrawalAddressRequest {
    withdrawalAddressId: string;
}

export interface Deposit {
    currencyCode: string;
    amount: string;
    destinationAddress: string;
    status: DepositStatus;
    txId: string | null;
    creationDate: Date;
    id: string;
    humanReadableIdentifier: string | null;
    description: string | null;
    numOfConfirmations: number;
    sourceAddress: string | null;
}

export interface DepositAddressRequest {
    accountNumber: string;
    blockchainCode: string;
    assetCode: string;
}

export interface DepositAddressResponse {
    address: string | null;
}

export interface DepositAddressResponseApiResponse {
    result: DepositAddressResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface DepositApiResponse {
    result: Deposit | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface DepositArrayPaginatedApiResponse {
    result: Deposit[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum DepositStatus {
    WaitingForConfirmation = "WaitingForConfirmation",
    Confirmed = "Confirmed",
    Cancelled = "Cancelled",
    Failed = "Failed",
    WaitingAdminAction = "WaitingAdminAction",
    Rejected = "Rejected",
    Verifying = "Verifying",
    Refunded = "Refunded",
}

export interface DisableAppAuthenticatorRequest {
    code: string;
    currentPassword: string | null;
}

export interface DisableAuth0MfaRequest {
}

export interface DisableGoogleAuthenticatorRequest {
    code: string;
    currentPassword: string | null;
}

export interface DismissAlertRequest {
    alertId: string;
}

export interface DismissUserMessageRequest {
    userMessageId: string;
}

export interface DownloadFactSheetsRequest {
    asset: string | null;
    year: number | null;
    month: number | null;
}

export interface DownloadFactSheetsResponse {
    url: string | null;
    fileName: string | null;
}

export interface DownloadFactSheetsResponseApiResponse {
    result: DownloadFactSheetsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface DownloadOrganizationDocumentRequest {
    type: OrganizationDocumentType;
}

export enum EmailTypes {
    NotDefined = "NotDefined",
    LoginSuccess = "LoginSuccess",
    WithdrawalInitiated = "WithdrawalInitiated",
    FiatWithdrawalInitiated = "FiatWithdrawalInitiated",
    ConfirmWithdrawal = "ConfirmWithdrawal",
    DepositSuccess = "DepositSuccess",
    FiatDepositSuccess = "FiatDepositSuccess",
    CreditCardDepositSuccess = "CreditCardDepositSuccess",
    ResetPassword = "ResetPassword",
    ResetPasswordAdmin = "ResetPasswordAdmin",
    AdminInvitation = "AdminInvitation",
    SecuritySettingsUpdated = "SecuritySettingsUpdated",
    UserInvitation = "UserInvitation",
    AccountLockedOut = "AccountLockedOut",
    ConfirmTransfer = "ConfirmTransfer",
    TransferInitiated = "TransferInitiated",
    TransferReceived = "TransferReceived",
    ReferreeRewardEligible = "ReferreeRewardEligible",
    EmailVerified = "EmailVerified",
    VerifyEmailAddress = "VerifyEmailAddress",
    VerifyBankAccount = "VerifyBankAccount",
    ConfirmWithdrawalAddress = "ConfirmWithdrawalAddress",
    ContactEmail = "ContactEmail",
    TransactionAborted = "TransactionAborted",
    KycDenied = "KycDenied",
    KycRejected = "KycRejected",
    KycApproved = "KycApproved",
    KycManualReview = "KycManualReview",
    KycEdd = "KycEdd",
    KycManualReviewAdminNotification = "KycManualReviewAdminNotification",
    KycCountryNotSupported = "KycCountryNotSupported",
    KycEddCompleted = "KycEddCompleted",
    YieldPayout = "YieldPayout",
    ReferreeRewardEarned = "ReferreeRewardEarned",
    ReferreeSignedUp = "ReferreeSignedUp",
    ReferrerRewardEarned = "ReferrerRewardEarned",
    EarlyReferrerRewardEarned = "EarlyReferrerRewardEarned",
    RewardMatchInKindAndReferrerRewardEligible = "RewardMatchInKindAndReferrerRewardEligible",
    RewardMatchInKindCancelled = "RewardMatchInKindCancelled",
    RewardMatchInKindEarned = "RewardMatchInKindEarned",
    RewardMatchInKindEligible = "RewardMatchInKindEligible",
    NewInvoice = "NewInvoice",
    AutoPayInvoiceFailed = "AutoPayInvoiceFailed",
    InstitutionalContactForm = "InstitutionalContactForm",
    FatcaReportReady = "FatcaReportReady",
    NewProspect = "NewProspect",
    ProspectFirstKycEmailFollowUp = "ProspectFirstKycEmailFollowUp",
    ProspectSecondKycEmailFollowUp = "ProspectSecondKycEmailFollowUp",
    ProspectThirdKycEmailFollowUp = "ProspectThirdKycEmailFollowUp",
}

export interface EnableAppAuthenticatorRequest {
    privateKey: string;
    code: string;
}

export interface EnableGoogleAuthenticatorRequest {
    privateKey: string;
    code: string;
}

export interface FactSheetItem {
    year: number;
    month: number;
}

export enum FeesChargedType {
    TerminationFee = "TerminationFee",
}

export interface FiatDeposit {
    readonly id: string;
    readonly humanReadableIdentifier: string | null;
    readonly amount: string | null;
    readonly creationDate: Date;
    readonly currency: Currency | null;
}

export interface FiatDepositApiResponse {
    result: FiatDeposit | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface FiatDepositArrayPaginatedApiResponse {
    result: FiatDeposit[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface FiatDepositDetails {
    currency: Currency | null;
    beneficiaryName: string | null;
    beneficiaryAddress: string | null;
    beneficiaryCity: string | null;
    beneficiaryCountry: string | null;
    beneficiaryPostalCode: string | null;
    accountNumber: string | null;
    iban: string | null;
    internationalBankNumber: string | null;
    localBankNumber: string | null;
    bankName: string | null;
    bankAddress: string | null;
    bankCity: string | null;
    bankCountry: string | null;
    bankPostalCode: string | null;
    requiredMemo: string | null;
    fundingAsset: Currency | null;
}

export interface FiatDepositDetailsApiResponse {
    result: FiatDepositDetails | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum FiatDepositRequestStatus {
    Pending = "Pending",
    Received = "Received",
    Cancelled = "Cancelled",
}

export interface FiatFund {
    currencyCode: string;
    currencyName: string;
    balance: string;
    underlyingCurrencyName: string;
    underlyingCurrencyCode: string;
    homeCurrencyEquivalent: string | null;
    homeCurrencyCurrencyCode: string;
    pendingSettlementBalance: string | null;
    pendingSettlementBalanceUsd: string | null;
    tradableBalance: string | null;
    withdrawableBalance: string | null;
    tradableBalanceUsd: string | null;
    withdrawableBalanceUsd: string | null;
}

export interface FiatMarketDetail {
    // @deprecated 
    price?: number | null;
    formattedPrice: string | null;
    change24hPercent: number | null;
}

export interface FiatWithdrawal {
    readonly id: string;
    humanReadableIdentifier: string | null;
    readonly accountNumber: string | null;
    readonly bankNumber: string | null;
    readonly status: FiatWithdrawalStatus;
    readonly amount: string | null;
    readonly fee: string | null;
    readonly description: string | null;
    readonly creationDate: Date;
    readonly currency: Currency | null;
    readonly canCancel: boolean;
    bankName: string | null;
    accountId: string;
}

export interface FiatWithdrawalApiResponse {
    result: FiatWithdrawal | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface FiatWithdrawalArrayPaginatedApiResponse {
    result: FiatWithdrawal[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface FiatWithdrawalSimulation {
    humanReadableIdentifier: string | null;
    amount: string | null;
    fee: string | null;
    description: string | null;
    currencyCode: string | null;
}

export interface FiatWithdrawalSimulationApiResponse {
    result: FiatWithdrawalSimulation | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum FiatWithdrawalStatus {
    Created = "Created",
    Processing = "Processing",
    Complete = "Complete",
    Cancelled = "Cancelled",
}

export interface FiatWithdrawalWithTimeline {
    timeline: Timeline | null;
    readonly id: string;
    humanReadableIdentifier: string | null;
    readonly accountNumber: string | null;
    readonly bankNumber: string | null;
    readonly status: FiatWithdrawalStatus;
    readonly amount: string | null;
    readonly fee: string | null;
    readonly description: string | null;
    readonly creationDate: Date;
    readonly currency: Currency | null;
    readonly canCancel: boolean;
    bankName: string | null;
    accountId: string;
}

export interface FiatWithdrawalWithTimelineApiResponse {
    result: FiatWithdrawalWithTimeline | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum FilteringActivityLabel {
    Traded = "Traded",
    Sent = "Sent",
    Received = "Received",
    CashAdded = "CashAdded",
    CashWithdrawn = "CashWithdrawn",
    YieldPayout = "YieldPayout",
    Reward = "Reward",
    Payment = "Payment",
    EarnedFee = "EarnedFee",
    InvoicePayment = "InvoicePayment",
    ChargedFee = "ChargedFee",
    TransferIn = "TransferIn",
    TransferOut = "TransferOut",
    FundSubscription = "FundSubscription",
    FundRedemption = "FundRedemption",
}

export interface FrontendConfigurationResponse {
    values: FrontendSingleConfiguration[] | null;
}

export interface FrontendConfigurationResponseApiResponse {
    result: FrontendConfigurationResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface FrontendSingleConfiguration {
    key: string | null;
    value: string | null;
}

export interface FundBalanceDetailDto {
    asset: Currency | null;
    secondaryAsset: Currency | null;
    valueIncludingPendingInSecondaryAsset: string | null;
    valueInSecondaryAsset: string | null;
    unitCostInSecondaryAsset: string | null;
    unitCostAsOf: Date;
    lastUpdatedDate: Date | null;
    shares: string | null;
    inceptionDate: Date | null;
    firstSubscriptionDate: Date | null;
    totalInvested: string | null;
    totalInvestedUsd: string | null;
}

export interface FundBenefitResponse {
    icon: string | null;
    title: string | null;
    text: string | null;
    footer: string | null;
}

export interface FundMarketDetail {
    currency: string | null;
    mtdRoR: number | null;
    ytdRoR: number | null;
    itdRoR: number | null;
    maxMonthlyDrawdown: number | null;
}

export interface FundPerformance {
    month: number | null;
    year: number;
    performancePercent: string | null;
}

export interface FxRate {
    rate: string | null;
    base: string | null;
    quote: string | null;
    baseDisplay: string | null;
    quoteDisplay: string | null;
    timestamp: Date;
    rate24HoursAgo: string | null;
    rate7DaysAgo: string | null;
    rate1MonthAgo: string | null;
    rate1YearAgo: string | null;
    unavailable: boolean;
    rate24HoursAgoDate: Date | null;
    rate7DaysAgoDate: Date | null;
    rate1MonthAgoDate: Date | null;
    rate1YearAgoDate: Date | null;
    rateDate: Date | null;
}

export interface FxTradeDetails {
    rate: string | null;
    rateContra: string | null;
    baseCurrency: string | null;
    quoteCurrency: string | null;
}

export interface GenerateUsersRequest {
    emailTemplate: string | null;
    rangeStart: number;
    rangeEnd: number;
    isAdmin: boolean;
}

export interface GetAccountBalanceHistoryMarkersRequest {
    startDate: Date | null;
    endDate: Date | null;
    assetCode: string;
}

export interface GetAccountBalanceHistoryMarkersResponse {
    markers: GraphMarker[] | null;
}

export interface GetAccountBalanceHistoryMarkersResponseApiResponse {
    result: GetAccountBalanceHistoryMarkersResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetAccountBalanceHistoryRequest {
    startDate: Date;
    endDate: Date;
    resolution: GetAccountBalanceHistoryResolution;
    baseAsset: string | null;
    quoteAsset: string | null;
}

export enum GetAccountBalanceHistoryResolution {
    Week1 = "Week1",
    Day1 = "Day1",
    Hour1 = "Hour1",
    Minute5 = "Minute5",
    Minute1 = "Minute1",
}

export interface GetAccountBalanceHistoryResponse {
    datapoints: DataPoint[] | null;
}

export interface GetAccountBalanceHistoryResponseApiResponse {
    result: GetAccountBalanceHistoryResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetAccountDetailsAsOfRequest {
    asOf: Date;
}

export interface GetAccountStatementRequest {
    start: Date;
    end: Date;
    currencyCode: string | null;
}

export interface GetAccountStatementResponse {
    statements: SingleCurrencyAccountStatement[] | null;
}

export interface GetAccountStatementResponseApiResponse {
    result: GetAccountStatementResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetActivityHistoryRequest {
    pageSize: number | null;
    /** Starts at 1 */
    page: number | null;
    /** Filter by currency code */
    currencyCodeFilter: string[] | null;
    dateStart: Date | null;
    dateEnd: Date | null;
    statusFilter: TransactionStatusFilter[] | null;
    sortColumn: SortColumn | null;
    sortDirection: SortDirection | null;
    activityLabels: ActivityLabel[] | null;
    elementId: string | null;
}

export interface GetActivityTransactionsRequest {
    pageSize: number | null;
    page: number | null;
    currencyCodeFilter: string[] | null;
    dateStart: Date | null;
    dateEnd: Date | null;
    statusFilter: TransactionStatusFilter[] | null;
    sortColumn: SortColumn | null;
    sortDirection: SortDirection | null;
    activityLabels: FilteringActivityLabel[] | null;
    elementId: string | null;
}

export interface GetAllAssetsHoldingsResponse {
    currencies: GetAssetHoldingsResponse[] | null;
    readonly totalQtyUsd: string | null;
    readonly totalPendingUsd: string | null;
}

export interface GetAllAssetsHoldingsResponseApiResponse {
    result: GetAllAssetsHoldingsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetApexFundRequest {
    accountId: string;
}

export interface GetApexFundsRequest {
    page: number;
    pageSize: number;
    search: string | null;
}

export interface GetAssetBalanceHistoryRequest {
    startDate: Date | null;
    endDate: Date | null;
    asset: string | null;
    periodType: PeriodType;
    performanceComputationMethod: PerformanceComputationMethod;
}

export interface GetAssetBalanceHistoryResponse {
    periodStart: Date;
    balance: string | null;
}

export interface GetAssetBalanceHistoryResponseArrayApiResponse {
    result: GetAssetBalanceHistoryResponse[] | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetAssetHoldingsRequest {
    currencyCode: string | null;
}

export interface GetAssetHoldingsResponse {
    currency: Currency | null;
    totalQty: string | null;
    accounts: AssetHolding[] | null;
    readonly totalQtyUsd: string | null;
    readonly totalPendingUsd: string | null;
    readonly totalTradableUsd: string | null;
    readonly totalWithdrawableUsd: string | null;
    readonly totalOpenOrdersUsd: string | null;
    readonly totalPendingOutgoingUsd: string | null;
    readonly totalPendingSendUsd: string | null;
    readonly totalPendingTransferOutUsd: string | null;
    readonly totalPendingIncomingUsd: string | null;
    readonly totalPendingReceiveUsd: string | null;
    readonly totalPendingTransferInUsd: string | null;
    readonly totalPendingSettlementUsd: string | null;
}

export interface GetAssetHoldingsResponseApiResponse {
    result: GetAssetHoldingsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetAuthenticationMethodRequest {
    emailAddress: string | null;
    siteCode: string | null;
}

export interface GetAuthenticationMethodResponse {
    authenticationMethod: AuthenticationType;
}

export interface GetAuthenticationMethodResponseApiResponse {
    result: GetAuthenticationMethodResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetBankAccountRequest {
    id: string;
}

export interface GetBankAccountsRequest {
}

export interface GetDepositAddressRequest {
    currencyCode: string | null;
}

export interface GetDepositAddressResponse {
    currencyCode: string | null;
    depositAddress: string | null;
}

export interface GetDepositAddressResponseApiResponse {
    result: GetDepositAddressResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetDepositHistoryRequest {
    pageSize: number | null;
    /** Starts at 1 */
    page: number | null;
}

export interface GetDepositRequest {
    depositId: string;
}

export interface GetFactSheetsRequest {
    asset: string | null;
    year: number | null;
}

export interface GetFactSheetsResponse {
    factSheets: FactSheetItem[] | null;
    years: number[] | null;
}

export interface GetFactSheetsResponseApiResponse {
    result: GetFactSheetsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetFeesChargedRequest {
    id: string;
}

export interface GetFiatDepositDetailsRequest {
    currencyCode: string;
}

export interface GetFiatDepositDetailsResponse {
    // @deprecated 
    id?: string;
    // @deprecated 
    status?: FiatDepositRequestStatus;
    // @deprecated 
    amount?: number;
    // @deprecated 
    currency?: string | null;
    beneficiaryName: string | null;
    beneficiaryAddress: string | null;
    beneficiaryCity: string | null;
    beneficiaryCountry: string | null;
    beneficiaryPostalCode: string | null;
    accountNumber: string | null;
    iban: string | null;
    internationalBankNumber: string | null;
    localBankNumber: string | null;
    bankName: string | null;
    bankAddress: string | null;
    bankCity: string | null;
    bankCountry: string | null;
    bankPostalCode: string | null;
    requiredMemo: string | null;
    fundingAsset: Currency | null;
}

export interface GetFiatDepositDetailsResponseApiResponse {
    result: GetFiatDepositDetailsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetFiatDepositHistoryRequest {
    pageSize: number | null;
    /** Starts at 1 */
    page: number | null;
}

export interface GetFiatDepositRequest {
    currencyCode: string;
}

export interface GetFiatWithdrawalHistoryRequest {
    pageSize: number | null;
    /** Starts at 1 */
    page: number | null;
}

export interface GetFiatWithdrawalRequest {
    id: string;
}

export interface GetFundFactsRequest {
    asset: string | null;
}

export interface GetFundFactsResponse {
    overview: string | null;
    minimumInvestmentInKind: string | null;
    minimumInvestmentUsd: string | null;
    isin: string | null;
    asOfDate: Date | null;
    inceptionDate: Date | null;
    liquidity: string | null;
    managementFee: number | null;
    performanceFee: number | null;
    auditor: string | null;
    investmentCurrency: string | null;
    subscriptions: string | null;
    investmentManager: string | null;
    fundAdmin: string | null;
    returnSinceInception: string | null;
    volumeSinceInception: string | null;
    returnVolumeRatio: string | null;
    eligibleInvestors: string | null;
    benefits: FundBenefitResponse[] | null;
    disclaimer: string | null;
    footnote: string | null;
    benefitsFootnote: string | null;
    volatilitySinceInception: string | null;
}

export interface GetFundFactsResponseApiResponse {
    result: GetFundFactsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetFundsAsOfRequest {
    asOf: Date;
}

export interface GetFundsResponse {
    funds: SingleFund[] | null;
    fiat: FiatFund[] | null;
    receivables: ReceivableFund[] | null;
}

export interface GetFundsResponseApiResponse {
    result: GetFundsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetFxRatesAsOfRequest {
    asOf: Date;
}

export interface GetFxRatesResponse {
    fxRates: FxRate[] | null;
}

export interface GetFxRatesResponseApiResponse {
    result: GetFxRatesResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetInvoiceDetailsRequest {
    id: string;
}

export interface GetInvoicePdfRequest {
    id: string;
}

export interface GetInvoicePdfResponse {
    id: string;
    uri: string | null;
}

export interface GetInvoicePdfResponseApiResponse {
    result: GetInvoicePdfResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetInvoicesRequest {
    pageSize: number | null;
    page: number | null;
    invoiceType: InvoiceItemType | null;
    dateStart: Date | null;
    dateEnd: Date | null;
}

export interface GetLatestTradesResponse {
    tradesByCurrency: LatestTradesByCurrency[] | null;
}

export interface GetLatestTradesResponseApiResponse {
    result: GetLatestTradesResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetMaximumTradableAmountResponse {
    funds: MaxTrade[] | null;
}

export interface GetMaximumTradableAmountResponseApiResponse {
    result: GetMaximumTradableAmountResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetMonthlyFundPerformancesRequest {
    asset: string | null;
    type: MonthlyFundPerformanceAssetType;
}

export interface GetMonthlyFundPerformancesResponse {
    performances: FundPerformance[] | null;
    ytdPerformances: FundPerformance[] | null;
}

export interface GetMonthlyFundPerformancesResponseApiResponse {
    result: GetMonthlyFundPerformancesResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetOrganizationDocumentResponse {
    url: string | null;
    organizationDocumentId: string;
}

export interface GetOrganizationDocumentResponseApiResponse {
    result: GetOrganizationDocumentResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetPaymentHistoryRequest {
    pageSize: number | null;
    /** Starts at 1 */
    page: number | null;
}

export interface GetPaymentRequest {
    id: string | null;
    clientId: string | null;
}

export interface GetReferralActivationStatusResponse {
    referralEnabled: boolean;
}

export interface GetReferralActivationStatusResponseApiResponse {
    result: GetReferralActivationStatusResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetReferralsResponse {
    referrals: Referral[] | null;
}

export interface GetReferralsResponseApiResponse {
    result: GetReferralsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetRewardRequest {
    id: string;
}

export interface GetRewardsResponse {
    rewards: Reward[] | null;
}

export interface GetRewardsResponseApiResponse {
    result: GetRewardsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetStatementPdfResponse {
    url: string | null;
    fileName: string | null;
}

export interface GetStatementPdfResponseApiResponse {
    result: GetStatementPdfResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetTagResponse {
    account: string;
    tag: string | null;
}

export interface GetTagResponseApiResponse {
    result: GetTagResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface GetTradableAssetsRequest {
    search: string | null;
    assetFrom: string | null;
    side: Side | null;
}

export interface GetTradeHistoryRequest {
    pageSize: number | null;
    /** Starts at 1 */
    page: number | null;
    /** Filter by currency code */
    currency1: string | null;
    /** Filter by currency code */
    currency2: string | null;
    dateStart: Date | null;
    dateEnd: Date | null;
}

export interface GetTradeStatusRequest {
    id: string;
}

export interface GetTransferHistoryRequest {
    pageSize: number | null;
    /** Starts at 1 */
    page: number | null;
}

export interface GetTransferRequest {
    id: string;
}

export interface GetWithdrawalAddress {
    id: string;
}

export interface GetWithdrawalAddresses {
}

export interface GetWithdrawalHistoryRequest {
    pageSize: number | null;
    /** Starts at 1 */
    page: number | null;
}

export interface GetWithdrawalStatusRequest {
    id: string | null;
    clientId: string | null;
}

export interface GraphMarker {
    shares: string | null;
    totalInvestedInUsd: string | null;
    totalInvestedInKind: string | null;
    markerOperation: MarkerOperation;
    date: Date;
    asset: string | null;
    secondaryAssetCode: string | null;
}

export interface GroupedAccountStatement {
    periodName: string | null;
    periodType: string | null;
    statements: AccountStatement[] | null;
}

export interface GroupedAccountStatementArrayPaginatedApiResponse {
    result: GroupedAccountStatement[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface InterestAccrual {
    date: Date;
    payoutDate: Date;
    currency: Currency | null;
    effectiveBalance: number;
    interestAmount: number;
    interestAmountUsd: number;
    readonly status: InterestAccrualStatus;
}

export enum InterestAccrualStatus {
    Pending = "Pending",
    Paid = "Paid",
}

export interface InterestHistoryRequest {
    dateStart: Date | null;
    dateEnd: Date | null;
}

export interface InterestHistoryResponse {
    accruals: InterestAccrual[] | null;
}

export interface InterestHistoryResponseApiResponse {
    result: InterestHistoryResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum InterestPayment {
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    SemiAnnual = "SemiAnnual",
    Yearly = "Yearly",
}

export interface InterestRate {
    readonly asset: Currency | null;
    readonly firstTierSize: number | null;
    readonly firstTierYield: number;
    readonly firstTierMinimumSize: number | null;
    readonly secondTierSize: number | null;
    readonly secondTierYield: number | null;
}

export interface InterestRateResponse {
    rates: InterestRate[] | null;
}

export interface InterestRateResponseApiResponse {
    result: InterestRateResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface InternalTransfer {
    readonly sourceAccountId: string;
    readonly destinationAccountId: string;
    readonly sourceAccountNumber: string | null;
    readonly destinationAccountNumber: string | null;
    readonly sourceAccountLabel: string | null;
    readonly destinationAccountLabel: string | null;
    readonly txId: string | null;
    readonly currencyCode: string | null;
    readonly amount: string | null;
    amountUsd: string | null;
    readonly senderTag: string | null;
    readonly destinationTag: string | null;
    readonly description: string | null;
    fee: string | null;
    feeUsd: string | null;
    totalAmountUsd: string | null;
    readonly status: TransferStatus;
    readonly creationDate: Date;
    readonly id: string;
    readonly humanReadableIdentifier: string | null;
    readonly kind: TransferKind;
    readonly canCancel: boolean;
    readonly clientId: string | null;
    feeCurrency: string | null;
    holdExpirationDate: Date | null;
    accountId: string;
    feeMode: WithdrawalFeeChargeMode;
    requireEmailCodeVerification: boolean;
    sendingAmount: string | null;
    sendingAmountUsd: string | null;
}

export interface InternalTransferApiResponse {
    result: InternalTransfer | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface InternalTransferWithTimeline {
    timeline: Timeline | null;
    readonly sourceAccountId: string;
    readonly destinationAccountId: string;
    readonly sourceAccountNumber: string | null;
    readonly destinationAccountNumber: string | null;
    readonly sourceAccountLabel: string | null;
    readonly destinationAccountLabel: string | null;
    readonly txId: string | null;
    readonly currencyCode: string | null;
    readonly amount: string | null;
    amountUsd: string | null;
    readonly senderTag: string | null;
    readonly destinationTag: string | null;
    readonly description: string | null;
    fee: string | null;
    feeUsd: string | null;
    totalAmountUsd: string | null;
    readonly status: TransferStatus;
    readonly creationDate: Date;
    readonly id: string;
    readonly humanReadableIdentifier: string | null;
    readonly kind: TransferKind;
    readonly canCancel: boolean;
    readonly clientId: string | null;
    feeCurrency: string | null;
    holdExpirationDate: Date | null;
    accountId: string;
    feeMode: WithdrawalFeeChargeMode;
    requireEmailCodeVerification: boolean;
    sendingAmount: string | null;
    sendingAmountUsd: string | null;
}

export interface InternalTransferWithTimelineApiResponse {
    result: InternalTransferWithTimeline | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface Invoice {
    id: string;
    number: number;
    organizationId: string;
    organizationName: string | null;
    quoteAssetCode: string | null;
    amount: string | null;
    paymentAssetCode: string | null;
    amountPaid: string | null;
    paymentAssetAccepted: PaymentAssetAccepted;
    creationDate: Date;
    dueDate: Date;
    status: InvoiceStatus;
    acceptedPaymentAssets: string[] | null;
    rows: InvoiceRow[] | null;
    isPdfReady: boolean;
    paymentAccountId: string;
    paymentAccountNumber: string | null;
    paymentAccountLabel: string | null;
    paymentAccountName: string | null;
    paymentAccountType: AccountType;
    referenceNumber: number;
}

export interface InvoiceApiResponse {
    result: Invoice | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface InvoiceArrayPaginatedApiResponse {
    result: Invoice[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface InvoiceGeneration {
    id: string;
    dueDate: Date;
    periodStartDate: Date;
    periodEndDate: Date;
    companyName: string | null;
    companyAddress: string | null;
    relationshipManager: StatementRelationship | null;
    quoteAsset: string | null;
    invoiceNumber: string | null;
    amount: string | null;
    taxes: string | null;
    taxRate: string | null;
    amountWithTaxes: string | null;
    rows: InvoiceGenerationRow[] | null;
}

export interface InvoiceGenerationPdfReportRequest {
    type: string | null;
    data: InvoiceGeneration | null;
}

export interface InvoiceGenerationPdfReportRequestApiResponse {
    result: InvoiceGenerationPdfReportRequest | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface InvoiceGenerationRow {
    amount: string | null;
    taxes: string | null;
    taxRate: string | null;
    amountWithTaxes: string | null;
    date: Date;
    accountId: string;
    accountLabel: string | null;
    accountNumber: string | null;
    type: string | null;
    withdrawal: WithdrawalInvoice | null;
    transfer: TransferInvoice | null;
}

export enum InvoiceItemType {
    CustodyFee = "CustodyFee",
    CustodyWithdrawal = "CustodyWithdrawal",
    Transfer = "Transfer",
    Manual = "Manual",
}

export interface InvoiceRow {
    date: Date;
    amount: string | null;
    type: InvoiceItemType;
    accountId: string;
    accountNumber: string | null;
    accountLabel: string | null;
    withdrawal: Withdrawal | null;
    transfer: Transfer | null;
}

export enum InvoiceStatus {
    WaitingPayment = "WaitingPayment",
    Paid = "Paid",
    Open = "Open",
    Cancelled = "Cancelled",
    WaitingForTalosSync = "WaitingForTalosSync",
}

export interface LastLoginDateResponse {
    ip: string;
    date: Date;
}

export interface LastLoginDateResponseApiResponse {
    result: LastLoginDateResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface LatestTradesByCurrency {
    currencyCode: string | null;
    trades: Trade[] | null;
}

export interface ListAccountItem {
    hasPendingBalance: boolean;
    // @deprecated 
    balanceOneDayAgo?: number | null;
    // @deprecated 
    balanceOneMonthAgo?: number | null;
    // @deprecated 
    readonly totalUsd?: string | null;
    totalAccountBalanceUsd: string | null;
    totalAccountPendingSettlementBalanceUsd: string | null;
    totalAccountTradableBalanceUsd: string | null;
    totalAccountWithdrawableBalanceUsd: string | null;
    totalOpenOrdersUsd: string | null;
    totalPendingTransferOutUsd: string | null;
    totalPendingSendUsd: string | null;
    totalPendingOutgoingUsd: string | null;
    totalPendingTransferInUsd: string | null;
    totalPendingReceiveUsd: string | null;
    totalPendingIncomingUsd: string | null;
    readonly canTrade: boolean;
    // @deprecated 
    readonly canAccountTransfer?: boolean;
    canSendAccountTransfer: boolean;
    canReceiveAccountTransfer: boolean;
    readonly canStabletagTransfer: boolean;
    readonly canReceiveCrypto: boolean;
    readonly canSendCrypto: boolean;
    readonly canReceiveCash: boolean;
    readonly canSendCash: boolean;
    readonly canPayInvoice: boolean;
    readonly earnedInterestTotalUsd: string | null;
    readonly earnedInterestThisWeekUsd: string | null;
    readonly canWithdrawToNonWhitelistedAddress: boolean;
    account: AccountProperties | null;
}

export interface ListAccountStatementRequest {
    startDate: Date | null;
    endDate: Date | null;
    accountId: string | null;
    assetCode: string | null;
    limit: number | null;
    page: number | null;
    accountTypes: AccountType[] | null;
}

export interface ListAccounts {
    totalPnL: string | null;
    // @deprecated 
    readonly totalUsd?: string | null;
    hasPendingBalance: boolean;
    readonly totalPortfolioBalanceUsd: string | null;
    readonly pendingIncomingBalanceUsd: string | null;
    readonly pendingReceiveBalanceUsd: string | null;
    readonly pendingTransferInBalanceUsd: string | null;
    readonly pendingOutgoingBalanceUsd: string | null;
    readonly pendingSendBalanceUsd: string | null;
    readonly pendingTransferOutBalanceUsd: string | null;
    readonly openOrdersBalanceUsd: string | null;
    readonly tradableBalanceUsd: string | null;
    readonly withdrawableBalanceUsd: string | null;
    readonly pendingSettlementBalanceUsd: string | null;
    balanceChange24HoursPercent: string | null;
    balanceChange1MonthPercent: string | null;
    balanceChange1MonthUsd: string | null;
    balanceChange24HoursUsd: string | null;
    accounts: ListAccountItem[] | null;
}

export interface ListAccountsApiResponse {
    result: ListAccounts | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface ListAssetDetailsRequest {
    assets: string[] | null;
    pageSize: number | null;
    page: number | null;
}

export interface ListAssetDetailsResponse {
    code: string | null;
    displayCode: string | null;
    name: string | null;
    types: MarketAssetType[] | null;
    categories: MarketAssetCategory[] | null;
    type: string | null;
    data: AssetDetailData | null;
    valueAsOf: Date | null;
    readonly isTrending: boolean;
    apy: number;
}

export interface ListAssetDetailsResponseArrayPaginatedApiResponse {
    result: ListAssetDetailsResponse[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface ListDepositableCurrenciesRequest {
    search: string | null;
    count: number;
}

export interface ListDepositableCurrenciesResponse {
    currencies: Currency[] | null;
    totalCount: number;
}

export interface ListDepositableCurrenciesResponseApiResponse {
    result: ListDepositableCurrenciesResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum MarkerOperation {
    Subscription = "Subscription",
    Redemption = "Redemption",
}

export enum MarketAssetCategory {
    Stablecoin = "Stablecoin",
    Memecoin = "Memecoin",
    Trending = "Trending",
    Top = "Top",
    Yield = "Yield",
}

export interface MarketAssetDetailsRequest {
    asset: string | null;
}

export interface MarketAssetDetailsResponse {
    asset: MarketAssetItemDetails | null;
}

export interface MarketAssetDetailsResponseApiResponse {
    result: MarketAssetDetailsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface MarketAssetItemDetails {
    description: string | null;
    useCase: string | null;
    proCon: string | null;
    ctaLink: string | null;
    ctaTitle: string | null;
    readonly name: string | null;
    readonly decimals: number;
    readonly pricePrecision: number;
    readonly code: string | null;
    readonly displayCode: string | null;
    readonly type: CurrencyType;
    readonly isStablecoin: boolean;
    readonly rate: string | null;
    readonly quote: string | null;
    readonly quoteDisplay: string | null;
    readonly timestamp: Date;
    readonly rate24HoursAgo: string | null;
    readonly rate7DaysAgo: string | null;
    readonly rate1MonthAgo: string | null;
    readonly rate1YearAgo: string | null;
    apy: string | null;
}

export interface MarketAssetListItem {
    readonly name: string | null;
    readonly decimals: number;
    readonly pricePrecision: number;
    readonly code: string | null;
    readonly displayCode: string | null;
    readonly type: CurrencyType;
    readonly isStablecoin: boolean;
    readonly rate: string | null;
    readonly quote: string | null;
    readonly quoteDisplay: string | null;
    readonly timestamp: Date;
    readonly rate24HoursAgo: string | null;
    readonly rate7DaysAgo: string | null;
    readonly rate1MonthAgo: string | null;
    readonly rate1YearAgo: string | null;
    apy: string | null;
}

export interface MarketAssetListItemArrayPaginatedApiResponse {
    result: MarketAssetListItem[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface MarketAssetListRequest {
    pageSize: number | null;
    /** Starts at 1 */
    page: number | null;
    sortDirection: SortDirection | null;
    sortColumn: MarketAssetListSortRequest | null;
}

export enum MarketAssetListSortRequest {
    Asset = "Asset",
    InstrumentType = "InstrumentType",
}

export enum MarketAssetType {
    Crypto = "Crypto",
    Fiat = "Fiat",
    Bond = "Bond",
    Fund = "Fund",
}

export interface MarketListAssetsRequest {
    types: MarketAssetType[] | null;
    categories: MarketAssetCategory[] | null;
    sortDirection: SortDirection | null;
    sortColumn: MarketListAssetsSortType | null;
    search: string | null;
    pageSize: number | null;
    page: number | null;
}

export enum MarketListAssetsSortType {
    Name = "Name",
    DisplayCode = "DisplayCode",
    MarketCap = "MarketCap",
    PercentageChange = "PercentageChange",
    Price = "Price",
    Volume = "Volume",
}

export interface MarketPageTopAssetResponse {
    gainers: ListAssetDetailsResponse[] | null;
    losers: ListAssetDetailsResponse[] | null;
}

export interface MarketPageTopAssetResponseApiResponse {
    result: MarketPageTopAssetResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface MarketStaticDataResponse {
    categoriesPerAssetType: CategoriesPerAssetTypeResponse[] | null;
}

export interface MarketStaticDataV2Response {
    categoriesPerAssetType: CategoriesPerAssetTypeV2Response[] | null;
}

export interface MaxTrade {
    currencyCode: string;
    currencyName: string;
    amount: string;
}

export enum MessageBehavior {
    Permanent = "Permanent",
    Dismissable = "Dismissable",
    Acceptable = "Acceptable",
}

export enum MessageTemplateAlertLevel {
    Success = "Success",
    Info = "Info",
    Warning = "Warning",
    Error = "Error",
    Brand = "Brand",
}

export enum MessageTemplateKind {
    Banner = "Banner",
    SplashScreen = "SplashScreen",
}

export enum MonthlyFundPerformanceAssetType {
    Usd = "Usd",
    InKind = "InKind",
}

export interface NotificationsSettings {
    receiveMarketingUpdates: boolean;
    receiveNewLoginNotifications: boolean;
    receiveTradeEmailNotifications: boolean;
}

export interface NotificationsSettingsApiResponse {
    result: NotificationsSettings | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface Ohlcv {
    date: Date;
    timestamp: string | null;
    open: string | null;
    high: string | null;
    low: string | null;
    close: string | null;
    volume: string | null;
}

export interface OhlcvArrayApiResponse {
    result: Ohlcv[] | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface OhlcvsRequest {
    base: string | null;
    quote: string | null;
    startDate: Date | null;
    endDate: Date | null;
    resolution: CandleResolutions;
}

export interface OperationDetailRequest {
    id: string;
}

export enum OrganizationDocumentType {
    Unknown = "Unknown",
    FeeSchedule = "FeeSchedule",
}

export interface OrganizationId {
    value: string;
}

export interface PasswordEntropyRequest {
    password: string | null;
}

export interface PasswordEntropyResponse {
    entropy: number;
    strength: string | null;
    isValid: boolean;
    requirementResults: SuggestedRequirementResult[] | null;
    message: string | null;
}

export interface PasswordEntropyResponseApiResponse {
    result: PasswordEntropyResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface PayInvoiceRequest {
    invoiceId: string;
    paymentAssetCode: string;
    paymentAccountId: string;
}

export interface Payment {
    currencyFrom: Currency | null;
    currencyTo: Currency | null;
    paymentStatus: PaymentStatus;
    creationDate: Date;
    executionDate: Date;
    txid: string | null;
    id: string;
    tradeId: string | null;
    readonly withdrawalId: string | null;
    readonly transferId: string | null;
    destination: string | null;
    /** Deprecated in favor of `destination`. */
    // @deprecated 
    readonly destinationAddress?: string | null;
    withdrawalStatus: WithdrawalStatus | null;
    transferStatus: TransferStatus | null;
    amountFrom: string | null;
    amountTo: string | null;
    makerFee: string | null;
    exchangeFee: string | null;
    fxRate: string | null;
    fxSymbol: string | null;
    withdrawalFee: string | null;
    // @deprecated 
    sendingNetworkFee?: string | null;
}

export interface PaymentApiResponse {
    result: Payment | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface PaymentArrayApiResponse {
    result: Payment[] | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum PaymentAssetAccepted {
    InKind = "InKind",
    AnyStablecoin = "AnyStablecoin",
    Any = "Any",
    AnyUSDBasedStablecoin = "AnyUSDBasedStablecoin",
    USDOnly = "USDOnly",
}

export enum PaymentDestinationType {
    Stabletag = "Stabletag",
    Address = "Address",
}

export interface PaymentSimulation {
    currencyFrom: string | null;
    currencyTo: string | null;
    /** If false, this payment , either due to insufficient user balance or insufficient liquidity. */
    canTrade: boolean;
    /** Specified if CanTrade is false due to insufficient liquidity. */
    maxAmountTo: string | null;
    /** Specified if CanTrade is false due to insufficient user balance. */
    maxAmountFrom: string | null;
    /** Deprecated; use MaxAmountTo. */
    readonly maxTradableAmount: string | null;
    amountFrom: string | null;
    amountTo: string | null;
    makerFee: string | null;
    exchangeFee: string | null;
    fxRate: string | null;
    fxSymbol: string | null;
    withdrawalFee: string | null;
    // @deprecated 
    sendingNetworkFee?: string | null;
}

export interface PaymentSimulationApiResponse {
    result: PaymentSimulation | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum PaymentStatus {
    WaitingForWithdrawal = "WaitingForWithdrawal",
    Completed = "Completed",
    Failed = "Failed",
    Cancelled = "Cancelled",
}

export interface PendingFiatDepositResponse {
    deposit: GetFiatDepositDetailsResponse | null;
}

export interface PendingFiatDepositResponseApiResponse {
    result: PendingFiatDepositResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface PendingOperationsRequest {
    page: number;
    types: QuorumOperationKind[] | null;
    entityIds: string[] | null;
}

export enum PerformanceComputationMethod {
    InKind = "InKind",
    Usd = "Usd",
}

export enum PeriodType {
    Monthly = "Monthly",
}

export interface ProblemDetails {
    type: string | null;
    title: string | null;
    status: number | null;
    detail: string | null;
    instance: string | null;
}

export enum PromotionType {
    Referrer = "Referrer",
    Referree = "Referree",
    MatchInKind = "MatchInKind",
}

export enum ProofOfAddressStatus {
    Unknown = "Unknown",
    PendingProofOfAddressUploadThroughNormalFlow = "PendingProofOfAddressUploadThroughNormalFlow",
    RequiresPrompt = "RequiresPrompt",
    SumsubVerificationPending = "SumsubVerificationPending",
    StablehouseVerificationPending = "StablehouseVerificationPending",
    VerifiedByStablehouse = "VerifiedByStablehouse",
    VerifiedBySumsub = "VerifiedBySumsub",
    RejectedBySumsub = "RejectedBySumsub",
    NotRelevant = "NotRelevant",
    NoOnfidoAccountToCompareAddressWith = "NoOnfidoAccountToCompareAddressWith",
    VerifiedByPartner = "VerifiedByPartner",
}

export interface ProvisionalAccountDetailAsset {
    currency: Currency | null;
    secondaryCurrency: Currency | null;
    type: ProvisionalFundAssetType;
    shares: number | null;
    value: number;
    valueUsd: number;
    asOf: Date;
    creationDate: Date;
}

export enum ProvisionalFundAssetType {
    Subscription = "Subscription",
    Redemption = "Redemption",
}

export interface PusherAuthenticationData {
    auth: string | null;
    channel_data: string | null;
}

export interface PusherAuthenticationDataApiResponse {
    result: PusherAuthenticationData | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface QuorumOperation {
    submittedByUserName: string | null;
    id: string;
    kind: QuorumOperationKind;
    status: QuorumOperationStatus;
    parameters: any | null;
    currentValues: any | null;
    elementId: string | null;
    submittedByUserId: string;
    submittedByUser: string | null;
    creationDate: Date;
    approvalDate: Date | null;
    cancelledDate: Date | null;
    failedDate: Date | null;
    failedReason: string | null;
    cancelledReason: string | null;
    requiredApprovals: number;
    approvals: QuorumOperationApproval[] | null;
}

export interface QuorumOperationApiResponse {
    result: QuorumOperation | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface QuorumOperationApproval {
    id: string;
    quorumOperationId: string;
    approvalDate: Date;
    approvalUserId: string;
    user: string | null;
    firstname: string | null;
    lastname: string | null;
}

export interface QuorumOperationArrayPaginatedApiResponse {
    result: QuorumOperation[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum QuorumOperationKind {
    CreateBankAccount = "CreateBankAccount",
    DeleteBankAccount = "DeleteBankAccount",
    ToggleAccountStatus = "ToggleAccountStatus",
    CreateWithdrawalAddress = "CreateWithdrawalAddress",
    DeleteWithdrawalAddress = "DeleteWithdrawalAddress",
    ToggleUserStatus = "ToggleUserStatus",
}

export enum QuorumOperationStatus {
    WaitingForApproval = "WaitingForApproval",
    Executed = "Executed",
    Cancelled = "Cancelled",
    Failed = "Failed",
}

export interface ReceivableFund {
    underlyingCurrencyCode: string;
    underlyingCurrencyName: string;
    amount: string;
    homeCurrencyEquivalent: string | null;
    homeCurrencyCurrencyCode: string;
}

export interface Referral {
    amountUsd: number;
    amountInCurrency: number | null;
    currency: string | null;
    // @deprecated 
    email?: string | null;
    firstname: string | null;
    // @deprecated 
    lastname?: string | null;
    status: ReferralStatus;
    creationDate: Date | null;
}

export enum ReferralStatus {
    Unknown = "Unknown",
    SignedUp = "SignedUp",
    Qualified = "Qualified",
    RewardEarned = "RewardEarned",
    Cancelled = "Cancelled",
}

export interface RegisterRequest {
    email: string;
    password: string;
    firstName: string;
    lastName: string;
    recaptchaToken: string;
    receiveMarketingUpdates: boolean;
    referralCode: string | null;
    tenant: string | null;
}

export interface RegisterResponse {
    token: string | null;
}

export interface RegisterResponseApiResponse {
    result: RegisterResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface ResendBankAccountVerificationCodeRequest {
    bankAccountId: string;
}

export interface ResendTransferVerificationCodeRequest {
    transferId: string;
}

export interface ResendVerificationEmailRequest {
    emailAddress: string;
    recaptchaToken: string;
    tenant: string | null;
}

export interface ResendWithdrawalAddressVerificationCodeRequest {
    withdrawalAddressId: string;
}

export interface ResendWithdrawalVerificationCodeRequest {
    withdrawalId: string;
}

export interface ResetPasswordEmailRequest {
    // @deprecated 
    email?: string | null;
    // @deprecated 
    tenant?: string | null;
    // @deprecated 
    siteCode?: string | null;
}

export interface Reward {
    amountInUsd: number;
    amountInCurrency: number | null;
    currency: string | null;
    firstname: string | null;
    status: RewardState;
    creationDate: Date | null;
    scheduledDeliveryDate: Date | null;
    promotion: PromotionType;
    id: string | null;
}

export interface RewardApiResponse {
    result: Reward | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum RewardName {
    ReferrerDepositAndHoldCreditsReferrer = "ReferrerDepositAndHoldCreditsReferrer",
    ReferrerDepositAndHoldCreditsReferree = "ReferrerDepositAndHoldCreditsReferree",
    Promocode = "Promocode",
    MatchInKind = "MatchInKind",
}

export enum RewardState {
    Unknown = "Unknown",
    SignedUp = "SignedUp",
    Qualified = "Qualified",
    RewardEarned = "RewardEarned",
    Cancelled = "Cancelled",
}

export interface SendEmail {
    htmlContent: string | null;
    subject: string | null;
    to: string[] | null;
    toAccount: string | null;
    toUser: string | null;
    toOrganizationOwner: OrganizationId | null;
    cc: string[] | null;
    bcc: string[] | null;
    replyTo: string | null;
    replyToName: string | null;
    userId: string | null;
    emailType: EmailTypes;
    data: any | null;
    templatePath: string | null;
    embeddedTemplatePath: string | null;
    headers: StringStringKeyValuePair[] | null;
    preHeader: string | null;
    emailCode: string | null;
    companyJurisdiction: CompanyJurisdictions;
}

export interface SetDepositDescriptionRequest {
    id: string;
    description: string | null;
}

export interface SetDevicePin {
    deviceId: string | null;
    pin: string | null;
}

export interface SetFundingRebateRequest {
    currencyCode: string;
    fundingRebateBps: number;
}

export interface SetLendingRateRequest {
    underlyingCurrencyCode: string;
    rate: number;
}

export interface SetReceivingRebateRequest {
    currencyCode: string;
    receivingRebateBps: number;
}

export interface SetTransferDescriptionRequest {
    id: string;
    description: string | null;
}

export interface SetWithdrawalDescriptionRequest {
    id: string;
    description: string | null;
}

export enum Side {
    Buy = "Buy",
    Sell = "Sell",
}

export interface SimplifiedListAsset {
    code: string | null;
    displayCode: string | null;
    name: string | null;
    types: MarketAssetType[] | null;
    categories: MarketAssetCategory[] | null;
    readonly isTrending: boolean;
}

export interface SimplifiedListAssetArrayPaginatedApiResponse {
    result: SimplifiedListAsset[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface SimulateFiatWithdrawalRequest {
    currencyCode: string;
    amount: string;
    subtractFeeFromAmount: boolean;
    description: string | null;
    // @deprecated 
    bankNumber?: string | null;
    // @deprecated 
    accountNumber?: string | null;
    bankAccountId: string | null;
}

export interface SimulatePaymentRequest {
    currencyTo: string;
    amountFrom: string | null;
    amountTo: string | null;
    currencyFrom: string | null;
    // @deprecated 
    destinationAddress?: string | null;
    /** Specifies whether the simulation should occur for a Stabletag destination,
or a blockchain address. If the type is `Address`, blockchain fees will be included
in the calculation. */
    destinationType: PaymentDestinationType | null;
}

export interface SimulateTradeRequest {
    currencyFrom: string;
    currencyTo: string;
    amountFrom: string | null;
    amountTo: string | null;
    /** If AmountFrom and AmountTo are both specified,
SidePreference will be used to determine whether
the fixed amount is on the buy (To) side or the sell (From) side. */
    sidePreference: TradeSide | null;
    clientId: string | null;
}

export interface SimulateWithdrawalRequest {
    currencyCode: string;
    amount: string;
    destinationAddress: string | null;
    withdrawalAddressId: string | null;
    subtractFeeFromAmount: boolean;
    description: string | null;
    appAuthenticatorCode: string | null;
    // @deprecated 
    googleAuthenticatorCode?: string | null;
}

export interface SingleCurrencyAccountStatement {
    digitalCurrencyAccountSummary: SingleDigitalCurrencyAccountSummary | null;
    fiatCurrencyAccountSummary: SingleFiatCurrencyAccountSummary | null;
    operations: AccountStatementOperation[] | null;
    isEmpty: boolean;
    currencyName: string | null;
    currencyCode: string | null;
}

export interface SingleDigitalCurrencyAccountSummary {
    operationSummary: SingleDigitalCurrencyOperationSummary | null;
    beginning: string | null;
    ending: string | null;
}

export interface SingleDigitalCurrencyOperationSummary {
    deposits: string | null;
    withdrawals: string | null;
    transfers: string | null;
    trades: string | null;
    serviceFees: string | null;
    marketMakerFees: string | null;
    fundings: string | null;
    fundingRebates: string | null;
    loans: string | null;
    loanPayments: string | null;
    receivables: string | null;
}

export interface SingleFiatCurrencyAccountSummary {
    operationSummary: SingleFiatCurrencyOperationSummary | null;
    beginning: string | null;
    ending: string | null;
}

export interface SingleFiatCurrencyOperationSummary {
    trades: string | null;
    bankTransfers: string | null;
    fiatWithdrawals: string | null;
}

export interface SingleFund {
    currencyCode: string;
    currencyName: string;
    totalBalance: string;
    lockedBalance: string;
    pooledBalance: string;
    readonly availableBalance: string;
    readonly availablePooledBalance: string;
    readonly reservedPooledBalance: string;
    readonly allowReceive: boolean;
    readonly fundingRebateBps: string;
    readonly receivingRebateBps: string;
    underlyingCurrencyName: string;
    underlyingCurrencyCode: string;
    readonly loanBps: string;
    homeCurrencyEquivalent: string | null;
    homeCurrencyCurrencyCode: string;
    earnedInterestTotal: string | null;
    earnedInterestThisWeek: string | null;
    earnedInterestTotalHomeCurrency: string | null;
    earnedInterestThisWeekHomeCurrency: string | null;
    custodyBalance: string | null;
    pendingSettlementBalance: string | null;
    pendingSettlementBalanceUsd: string | null;
    tradableBalance: string | null;
    tradableBalanceUsd: string | null;
    withdrawableBalance: string | null;
    withdrawableBalanceUsd: string | null;
}

export enum SortColumn {
    Type = "Type",
    Date = "Date",
    Status = "Status",
}

export enum SortDirection {
    Ascending = "Ascending",
    Descending = "Descending",
}

export interface StakeFundsRequest {
    currencyCode: string;
    amount: string | null;
}

export interface Statement {
    startDate: Date;
    endDate: Date;
    accountName: string | null;
    accountNumber: string | null;
    accountBalance: string | null;
    openingValue: string | null;
    totalAdditions: string | null;
    totalSubtractions: string | null;
    changeInValue: string | null;
    closingValue: string | null;
    companyName: string | null;
    companyAddress: string | null;
    relationshipManager: StatementRelationship | null;
    holdings: StatementHoldings[] | null;
    activities: StatementActivity[] | null;
    accountId: string;
    statementId: string;
    companyJurisdiction: string | null;
}

export interface StatementActivity {
    date: Date;
    activityType: string | null;
    from: Balance | null;
    to: Balance | null;
    typeExtension: string | null;
    transferDestinationTag: string | null;
    transferDestinationAccountNumber: string | null;
    transferSourceTag: string | null;
    transferSourceAccountNumber: string | null;
    activityLabel: string | null;
    secondaryLabel: string | null;
}

export interface StatementHoldings {
    asset: string | null;
    amount: string | null;
    conversionRate: number;
    total: string | null;
}

export interface StatementPdfReportRequest {
    type: string | null;
    data: Statement | null;
}

export interface StatementPdfReportRequestApiResponse {
    result: StatementPdfReportRequest | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface StatementRelationship {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    phoneNumber: string | null;
    telegram: string | null;
}

export interface StaticDataResponse {
    markets: MarketStaticDataResponse | null;
}

export interface StaticDataResponseApiResponse {
    result: StaticDataResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface StaticDataV2Response {
    markets: MarketStaticDataV2Response | null;
}

export interface StaticDataV2ResponseApiResponse {
    result: StaticDataV2Response | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface StringApiResponse {
    result: string | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface StringStringKeyValuePair {
    key: string | null;
    value: string | null;
}

export enum SubAccountType {
    Regular = "Regular",
    Customer = "Customer",
    Merchant = "Merchant",
    Fund = "Fund",
}

export interface SuggestedRequirementResult {
    label: string | null;
    isMet: boolean;
}

export interface Timeline {
    instances: TimelineItem[] | null;
    readonly status: TimelineStatus;
    readonly title: string | null;
}

export interface TimelineItem {
    displayName: string | null;
    description: string | null;
    order: number;
    period: TimelineItemPeriod;
}

export enum TimelineItemPeriod {
    Past = "Past",
    Present = "Present",
    Future = "Future",
}

export enum TimelineStatus {
    Pending = "Pending",
    Completed = "Completed",
    Error = "Error",
}

export interface ToggleAccountStatusOperationRequest {
    state: boolean;
}

export interface ToggleUserStatusOperationRequest {
    state: boolean;
    userId: string;
}

export interface TradableAssetsResponse {
    // @deprecated 
    assets?: Currency[];
    tradableAssets: Currency[];
    nonTradableAssets: Currency[];
}

export interface TradableAssetsResponseApiResponse {
    result: TradableAssetsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface Trade {
    id: string;
    humanReadableIdentifier: string | null;
    currencyFrom: Currency | null;
    currencyTo: Currency | null;
    base: Currency | null;
    quote: Currency | null;
    side: Side | null;
    amountFrom: string | null;
    amountTo: string | null;
    fees: string | null;
    fxDetails: FxTradeDetails | null;
    creationDate: Date;
    status: TradeStatus;
    payment: Payment | null;
    clientId: string | null;
    amountFromHomeCurrencyEquivalent: string | null;
    amountToHomeCurrencyEquivalent: string | null;
    requestedQuantity: string | null;
    filledQuantity: string | null;
    requestedAsset: Currency | null;
    isPartialFill: boolean;
    hasEnoughFunds: boolean;
}

export interface TradeApiResponse {
    result: Trade | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface TradeArrayPaginatedApiResponse {
    result: Trade[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum TradeSide {
    From = "From",
    To = "To",
}

export interface TradeSimulation {
    currencyFrom: string | null;
    currencyTo: string | null;
    currencyDisplayFrom: string | null;
    currencyDisplayTo: string | null;
    underlyingCurrencyFrom: string | null;
    underlyingCurrencyTo: string | null;
    underlyingCurrencyDisplayFrom: string | null;
    underlyingCurrencyDisplayTo: string | null;
    amountFrom: string | null;
    amountTo: string | null;
    /** If false, this trade could not be executed, either due to insufficient user balance or insufficient liquidity. */
    canTrade: boolean;
    /** Specified if CanTrade is false due to insufficient liquidity. */
    maxAmountTo: string | null;
    /** Specified if CanTrade is false due to insufficient user balance. */
    maxAmountFrom: string | null;
    /** Deprecated; use MaxAmountTo. */
    readonly maxTradableAmount: string | null;
    makerFee: string | null;
    exchangeFee: string | null;
    totalFees: string | null;
    fxRate: string | null;
    fxRateContra: string | null;
    fxSymbol: string | null;
    amountFromHomeCurrencyEquivalent: string | null;
    amountToHomeCurrencyEquivalent: string | null;
    slippageBps: number;
    canPartiallyFill: boolean;
    isIndicative: boolean;
    hasEnoughFunds: boolean;
}

export interface TradeSimulationApiResponse {
    result: TradeSimulation | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum TradeStatus {
    Pending = "Pending",
    Executed = "Executed",
    Failed = "Failed",
}

export interface TradesCountSummary {
    totalTradesCount: number;
    failedTradesCount: number;
    pendingTradesCount: number;
    executedTradesCount: number;
}

export interface TradesCountSummaryApiResponse {
    result: TradesCountSummary | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface TradesSummaryRequest {
    dateStart: Date;
    dateEnd: Date;
    currency: string | null;
}

export interface TradesSummaryResponse {
    currencies: CurrencyTradesSummary[] | null;
}

export interface TradesSummaryResponseApiResponse {
    result: TradesSummaryResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface TradingStatus {
    tradingAllowed: boolean;
    reasonMessage: string | null;
    reasonTitle: string | null;
}

export interface TradingStatusApiResponse {
    result: TradingStatus | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum TransactionStatusFilter {
    Pending = "Pending",
    Completed = "Completed",
    Cancelled = "Cancelled",
    Rejected = "Rejected",
    Failed = "Failed",
}

export interface Transfer {
    readonly currencyCode: string | null;
    readonly amount: string | null;
    amountUsd: string | null;
    readonly senderTag: string | null;
    readonly destinationTag: string | null;
    readonly description: string | null;
    fee: string | null;
    feeUsd: string | null;
    totalAmountUsd: string | null;
    readonly status: TransferStatus;
    readonly creationDate: Date;
    readonly id: string;
    readonly humanReadableIdentifier: string | null;
    readonly kind: TransferKind;
    readonly canCancel: boolean;
    readonly clientId: string | null;
    feeCurrency: string | null;
    holdExpirationDate: Date | null;
    accountId: string;
    feeMode: WithdrawalFeeChargeMode;
    requireEmailCodeVerification: boolean;
    sendingAmount: string | null;
    sendingAmountUsd: string | null;
}

export interface TransferApiResponse {
    result: Transfer | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface TransferArrayPaginatedApiResponse {
    result: Transfer[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface TransferInvoice {
    currencyCode: string | null;
    amount: string | null;
    amountUsd: string | null;
    senderTag: string | null;
    destinationTag: string | null;
    description: string | null;
    creationDate: Date;
    id: string;
    humanReadableIdentifier: string | null;
    kind: string | null;
    clientId: string | null;
    destinationAccountLabel: string | null;
    destinationAccountNumber: string | null;
    sourceAccountLabel: string | null;
    sourceAccountNumber: string | null;
}

export enum TransferKind {
    Outgoing = "Outgoing",
    Incoming = "Incoming",
}

export interface TransferSimulation {
    homeCurrencyEquivalent: number;
    readonly currencyCode: string | null;
    readonly amount: string | null;
    amountUsd: string | null;
    readonly senderTag: string | null;
    readonly destinationTag: string | null;
    readonly description: string | null;
    fee: string | null;
    feeUsd: string | null;
    totalAmountUsd: string | null;
    readonly status: TransferStatus;
    readonly creationDate: Date;
    readonly id: string;
    readonly humanReadableIdentifier: string | null;
    readonly kind: TransferKind;
    readonly canCancel: boolean;
    readonly clientId: string | null;
    feeCurrency: string | null;
    holdExpirationDate: Date | null;
    accountId: string;
    feeMode: WithdrawalFeeChargeMode;
    requireEmailCodeVerification: boolean;
    sendingAmount: string | null;
    sendingAmountUsd: string | null;
}

export interface TransferSimulationApiResponse {
    result: TransferSimulation | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum TransferStatus {
    WaitingForConfirmation = "WaitingForConfirmation",
    Confirmed = "Confirmed",
    Executed = "Executed",
    Failed = "Failed",
    Cancelled = "Cancelled",
    Pending = "Pending",
    Unlocking = "Unlocking",
}

export interface TransferWithTimeline {
    timeline: Timeline | null;
    readonly currencyCode: string | null;
    readonly amount: string | null;
    amountUsd: string | null;
    readonly senderTag: string | null;
    readonly destinationTag: string | null;
    readonly description: string | null;
    fee: string | null;
    feeUsd: string | null;
    totalAmountUsd: string | null;
    readonly status: TransferStatus;
    readonly creationDate: Date;
    readonly id: string;
    readonly humanReadableIdentifier: string | null;
    readonly kind: TransferKind;
    readonly canCancel: boolean;
    readonly clientId: string | null;
    feeCurrency: string | null;
    holdExpirationDate: Date | null;
    accountId: string;
    feeMode: WithdrawalFeeChargeMode;
    requireEmailCodeVerification: boolean;
    sendingAmount: string | null;
    sendingAmountUsd: string | null;
}

export interface TransferWithTimelineApiResponse {
    result: TransferWithTimeline | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface TravelRuleExchangeSearchRequest {
    query: string;
    limit: number | null;
}

export interface TravelRuleExchangeSearchResponse {
    id: string | null;
    label: string | null;
}

export interface TravelRuleExchangeSearchResponseArrayApiResponse {
    result: TravelRuleExchangeSearchResponse[] | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum TravelRuleWalletOwnerType {
    Self = "Self",
    Individual = "Individual",
    Company = "Company",
}

export enum TravelRuleWalletType {
    Centralized = "Centralized",
    Decentralized = "Decentralized",
}

export interface TwoFaAfterLogin {
    showPage: boolean;
    bypass: boolean;
}

export interface UnstakeFundsRequest {
    currencyCode: string;
    amount: string | null;
}

export interface UpdateAccountLabelRequest {
    label: string;
}

export interface UpdatePasswordRequest {
    currentPassword: string;
    newPassword: string;
}

export interface UpdatePinResult {
    pin: string | null;
    deviceId: string | null;
    userId: string;
}

export interface UpdatePinResultApiResponse {
    result: UpdatePinResult | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface UserAlert {
    id: string;
    kind: UserAlertKind;
    text: string | null;
    icon: string | null;
    backgroundColor: string | null;
    textColor: string | null;
    ctaLink: string | null;
    dismissable: boolean;
    creationDate: Date;
    expirationDate: Date | null;
    dismissed: boolean;
    showOnce: boolean;
}

export enum UserAlertKind {
    KycSuccessful = "KycSuccessful",
    ProofOfAddressApproved = "ProofOfAddressApproved",
}

export interface UserAndRole {
    active: boolean;
    creationDate: Date;
    isOwner: boolean;
    canTrade: boolean;
    canCreateApiKeys: boolean;
    canWithdraw: boolean;
    disableEmailNotifications: boolean;
    firstname: string | null;
    lastname: string | null;
    email: string | null;
    userType: UserType;
    userId: string;
}

export interface UserAndRoleArrayApiResponse {
    result: UserAndRole[] | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface UserInfo {
    accountName: string | null;
    fistname: string | null;
    lastname: string | null;
    password: string | null;
    emailAddress: string | null;
}

export interface UserInfoApiResponse {
    result: UserInfo | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum UserType {
    Regular = "Regular",
    ClientAdminReadOnly = "ClientAdminReadOnly",
    ClientAdminReadWrite = "ClientAdminReadWrite",
}

export interface UserUnseenMessageTemplateDto {
    id: string;
    messageKind: MessageTemplateKind;
    bannerTitle: string | null;
    bannerText: string | null;
    bannerLinkText: string | null;
    bannerLinkUrl: string | null;
    alertLevel: MessageTemplateAlertLevel | null;
    splashScreenTitle: string | null;
    splashScreenSubtitle: string | null;
    splashScreenText: string | null;
    splashScreenPdfUrl: string | null;
    splashScreenAckText: string | null;
    behavior: MessageBehavior;
}

export interface UserUnseenMessageTemplateDtoArrayApiResponse {
    result: UserUnseenMessageTemplateDto[] | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface ValidateAddressRequest {
    address: string;
    blockchainCode: string;
}

export interface ValidateAddressResponse {
    blockchainCode: string | null;
    isValid: boolean | null;
    requestedAddress: string | null;
    normalizedAddress: string | null;
    normalized: boolean;
    validationStatus: AddressValidationStatus;
}

export interface ValidateAddressResponseApiResponse {
    result: ValidateAddressResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface ValidateDevicePin {
    deviceId: string | null;
    pin: string | null;
}

export interface ValidateInvitationCodeRequest {
    email: string;
    prefineryValidationCode: string;
}

export interface ValidateReferralCodeRequest {
    referralCode: string;
}

export interface ValidateReferralCodeResponse {
    isValid: boolean;
}

export interface ValidateReferralCodeResponseApiResponse {
    result: ValidateReferralCodeResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface ValidateTagRequest {
    tag: string;
}

export interface ValidateTagResponse {
    tag: string | null;
    valid: boolean;
    exist: boolean;
    isSelf: boolean;
    canTransfer: boolean;
}

export interface ValidateTagResponseApiResponse {
    result: ValidateTagResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface VerifyBankAccountRequest {
    bankAccountId: string;
    code: string | null;
    appAuthenticatorCode: string | null;
}

export interface VerifyEmailAddressRequest {
    token: string;
}

export interface VerifyEmailAddressResponse {
}

export interface VerifyEmailAddressResponseApiResponse {
    result: VerifyEmailAddressResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface VerifyPinResult {
    jwt: string | null;
}

export interface VerifyPinResultApiResponse {
    result: VerifyPinResult | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface WhiteLabelLiteSettings {
    isWhiteLabelLite: boolean;
    logoUrl: string | null;
    text: string | null;
    textLocation: WhiteLabelLiteSettingsTextLocation;
}

export enum WhiteLabelLiteSettingsTextLocation {
    Undefined = "Undefined",
    Left = "Left",
    Right = "Right",
}

export interface Withdrawal {
    currencyCode: string;
    amount: string;
    destinationAddress: string;
    withdrawalAddress: string | null;
    withdrawalAddressLabel: string | null;
    status: WithdrawalStatus;
    txId: string | null;
    creationDate: Date;
    id: string;
    humanReadableIdentifier: string | null;
    description: string | null;
    amountSent: string | null;
    fees: string | null;
    invoicedFee: string | null;
    invoicedFeeUsd: string | null;
    invoicedFeeCurrencyCode: string | null;
    readonly canCancel: boolean;
    amountSentUsd: string | null;
    confirmations: number;
    accountId: string;
    holdExpirationDate: Date | null;
    feeMode: WithdrawalFeeChargeMode;
    requireEmailCodeVerification: boolean;
    // @deprecated 
    withdrawalAddressId?: string | null;
}

export interface WithdrawalAddress {
    readonly id: string;
    readonly label: string | null;
    readonly currencyCode: string;
    readonly currencyDisplayCode: string;
    readonly address: string;
    status: WithdrawalAddressStatus;
    timelockExpireDate: Date | null;
    readonly isVerifying: boolean;
    readonly creationDate: Date;
}

export interface WithdrawalAddressApiResponse {
    result: WithdrawalAddress | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface WithdrawalAddressArrayApiResponse {
    result: WithdrawalAddress[] | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum WithdrawalAddressStatus {
    Verifying = "Verifying",
    Ready = "Ready",
    Deleted = "Deleted",
    Aborted = "Aborted",
    PendingTimeLock = "PendingTimeLock",
    CanceledBySystem = "CanceledBySystem",
    Expired = "Expired",
    Canceled = "Canceled",
}

export interface WithdrawalApiResponse {
    result: Withdrawal | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface WithdrawalArrayPaginatedApiResponse {
    result: Withdrawal[] | null;
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum WithdrawalFeeChargeMode {
    ChargedImmediately = "ChargedImmediately",
    Invoiced = "Invoiced",
}

export interface WithdrawalInvoice {
    amount: string | null;
    currencyCode: string | null;
    destinationAddress: string | null;
    creationDate: Date;
    id: string;
}

export interface WithdrawalRequirementsDataResponse {
    walletOwnerName: boolean | null;
    walletPlatform: boolean | null;
}

export interface WithdrawalRequirementsRequest {
    asset: string;
    amount: string;
    address: string;
}

export interface WithdrawalRequirementsResponse {
    isValid: boolean;
    organizationTravelRuleAddressInfoId: string | null;
    dataRequired: WithdrawalRequirementsDataResponse | null;
    beneficiaryVaspDid: string | null;
}

export interface WithdrawalRequirementsResponseApiResponse {
    result: WithdrawalRequirementsResponse | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export interface WithdrawalSimulation {
    currencyCode: string | null;
    /** Amount that will be taken from the user's balance. */
    amount: string | null;
    homeCurrencyAmount: string | null;
    /** Amount - TotalFee. */
    sendingAmount: string | null;
    homeCurrencySendingAmount: string | null;
    transactionFee: string | null;
    // @deprecated 
    totalFee?: string | null;
    destinationAddress: string | null;
    description: string | null;
    // @deprecated 
    withdrawalAddressId?: string | null;
    withdrawalAddress: string | null;
    withdrawalAddressLabel: string | null;
    invoicedFee: string | null;
    invoicedFeeAsset: string | null;
    invoicedFeeUsd: string | null;
    feeMode: WithdrawalFeeChargeMode;
    requestedAddress: string | null;
    normalizedAddress: string | null;
    normalized: boolean;
}

export interface WithdrawalSimulationApiResponse {
    result: WithdrawalSimulation | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum WithdrawalStatus {
    Initiated = "Initiated",
    WaitingForConfirmation = "WaitingForConfirmation",
    Confirmed = "Confirmed",
    Cancelled = "Cancelled",
    Failed = "Failed",
    PendingUserEmailConfirmation = "PendingUserEmailConfirmation",
    Verifying = "Verifying",
    Unlocking = "Unlocking",
}

export interface WithdrawalWithTimeline {
    timeline: Timeline | null;
    currencyCode: string;
    amount: string;
    destinationAddress: string;
    withdrawalAddress: string | null;
    withdrawalAddressLabel: string | null;
    status: WithdrawalStatus;
    txId: string | null;
    creationDate: Date;
    id: string;
    humanReadableIdentifier: string | null;
    description: string | null;
    amountSent: string | null;
    fees: string | null;
    invoicedFee: string | null;
    invoicedFeeUsd: string | null;
    invoicedFeeCurrencyCode: string | null;
    readonly canCancel: boolean;
    amountSentUsd: string | null;
    confirmations: number;
    accountId: string;
    holdExpirationDate: Date | null;
    feeMode: WithdrawalFeeChargeMode;
    requireEmailCodeVerification: boolean;
    // @deprecated 
    withdrawalAddressId?: string | null;
}

export interface WithdrawalWithTimelineApiResponse {
    result: WithdrawalWithTimeline | null;
    readonly timestamp: number;
    isSuccessful: boolean;
    errorMessage: string | null;
    errorCode: number | null;
    requestId: string | null;
}

export enum YieldPromptAction {
    Accepted = "Accepted",
    Declined = "Declined",
}

export interface YieldPromptRequest {
    action: YieldPromptAction;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

const HEADER_X_ACCOUNT_ID = 'x-account-id';
const EXCLUDE_HEADER_X_ACCOUNT_ID_ENDPOINTS = ['v1/currencies'];